import * as angular from 'angular';
import { DEFAULT_DISRUPTION_TYPE_MODEL, DisruptionTypeModel } from './models/disruption-type.model';
import { MmBDatalayerUtilsService } from '@src/components/services/ib-MmB-datalayer/services/ib-MmB-datalayer-utils-service';
import dayjs from 'dayjs';
import { MMBDatalayerConstants } from '../ib-MmB-datalayer/constants/ib-MmB-datalayer-constants';
import { OnHoldModel } from '@src/app/core/models/import-order-model/import-onhold-model';
@Service(
    'ib-MmB-services-module',
    ['IbCAuthTokenService', '$window', 'CommonsSessionStorageService', 'MmBAppConstants', '$filter', 'MmBModalService', '$sce', '$rootScope', 'CurrencyService', '$cookies', 'MmBDatalayerUtilsService', '$location', 'CommonsUtilService', 'DatalayerUniqueKeysService','$translate'],
    []
)
export class MmBUtilService {

    constructor (
        private IbCAuthTokenService: IbCAuthTokenService,
        private $window: angular.IWindowService,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private MmBAppConstants,
        private $filter: ng.FilterFactory,
        private MmBModalService,
        private $sce: ng.ISCEService,
        private $rootScope: CommonsRootScope,
        private CurrencyService: CurrencyService,
        private $cookies: angular.cookies.ICookiesService,
        private MmBDatalayerUtilsService: MmBDatalayerUtilsService,
        private $location: angular.ILocationService,
        private CommonsUtilService: CommonsUtilService,
        private DatalayerUniqueKeysService: DatalayerUniqueKeysService,
        private $translate: any
    ) {}

    /**
    * Set Dynamic_pricing_seat in datalayer_general
    */
    updateDinamicPricingDatalayer = () => {
        const isDP = this.getDynamicPPricingCookieParameter();
        let datalayerObject = {};
        isDP ? datalayerObject = { Dynamic_pricing_seat: MMBDatalayerConstants.DATALAYER_VALUES.YES } : datalayerObject = { Dynamic_pricing_seat: MMBDatalayerConstants.DATALAYER_VALUES.NO };
        /* INIT DELETE GA4 MIGRATION*/
        this.MmBDatalayerUtilsService.addDataLayerInfo(datalayerObject);
        /* FINISH DELETE GA4 MIGRATION*/
        this.MmBDatalayerUtilsService.addDigitalDataInfo(datalayerObject);
    };

    /**
     * return if Dinamic Pricing is active on the Cookie
     */
    private getDynamicPPricingCookieParameter = () => {
        const isDPCookie = this.$cookies.get(this.MmBAppConstants.COOKIES.DYNAMIC_PRICING);
        return isDPCookie;
    };

    ////////////////
    /**
     * Returns the type of the device depending on the channel and the width of the screen.
     * @returns {Object.<Promise>} - returns a string. desktop|tablet|mobile
     */
    getDeviceType = () => {
        let width;
        let deviceType = '';
        const channel = this.CommonsSessionStorageService.get('channel');
        if (channel === 'mobi') {
            deviceType = 'mobile';
        } else {
            width = this.$window.innerWidth;
            if (width != null) {
                if (width > 1024) {
                    deviceType = 'desktop';
                } else if (width > 480 && width < 1025) {
                    deviceType = 'tablet';
                } else if (width < 481) {
                    deviceType = 'mobile';
                }
            }
        }
        return deviceType;
    };

    /**
     * Refresh the current token storing it in Session Storage. If the user is logged the function refresh the user logged token.
     * If not, gets a new anonymous token and stores it
     * @returns {Object.<Promise>} - returns a promise. When the token is refreshed, then resolves the promise. If the refresh fails, then it resolves de promise equally
     */
    refreshToken = () => {
        return new Promise((resolve, reject) => {
            if (this.CommonsSessionStorageService.get('userLogged')) {
                this.IbCAuthTokenService.refreshUserLoggedToken().then(() => resolve(null), () => {
                    this.CommonsSessionStorageService.set('userLogged', false);
                    this.IbCAuthTokenService.getAnonymousToken().then(() => resolve(null), () => resolve(null));
                });
            } else {
                this.IbCAuthTokenService.getAnonymousToken().then(() => resolve(null), () => resolve(null));
            }
        });
    };

    /**
     * check if the current user is logged or not
     * @return true if the user is logged in the app
     */
    isUserLogged = () => {
        if (!this.CommonsSessionStorageService.get('userLogged')) {
            this.$cookies.remove('userLogged');
        } else {
            this.$cookies.put('userLogged', 'true');
        }
        return this.CommonsSessionStorageService.get('userLogged');
    };

    getDateFormatted = (day, month, year) => {
        const parsedDay = day < 10 ? '0' + day : day;
        const parsedMonth = month < 10 ? '0' + month : month;
        return year + '-' + parsedMonth + '-' + parsedDay;
    };

    /**
     * Remove all localstorage variables of the app
     */
    initStorage = () => {
        this.CommonsSessionStorageService.clearAll(/(?!(ib-MmB-app).*)^(ib-[\w\-]+-app\.[\w\-]+)/i, { withPrefix: false });
        this.CommonsSessionStorageService.remove('paySucces');
        this.CommonsSessionStorageService.remove('contactData');
        this.CommonsSessionStorageService.remove('savedDataContactSuccess');
        this.CommonsSessionStorageService.remove('bookingsList');
        this.CommonsSessionStorageService.remove('redirectionPaymentCallback');
        this.CommonsSessionStorageService.remove('bookingInfo');
        this.CommonsSessionStorageService.remove('otherFees');
        this.CommonsSessionStorageService.remove('selectInsurance');
        this.CommonsSessionStorageService.remove('headerModelLocal');
        this.CommonsSessionStorageService.remove('ancillariesAvailablePassengers');
        this.CommonsSessionStorageService.remove('ancillariesAvailableSegments');
        this.CommonsSessionStorageService.remove('headerModel');
        this.CommonsSessionStorageService.remove('seatMapSegment');
        this.CommonsSessionStorageService.remove('currency');
        this.CommonsSessionStorageService.remove('flightsInfo');
        this.CommonsSessionStorageService.remove('orderItemsInfo');
        this.CommonsSessionStorageService.remove('selectedPaymentData');
        this.CommonsSessionStorageService.remove('commercialInfo');
        this.CommonsSessionStorageService.remove('insuranceSelected');
        this.CommonsSessionStorageService.remove('breakDownInfo');
        this.CommonsSessionStorageService.remove('seatsQuanty');
        this.CommonsSessionStorageService.remove('PaymentMethods');
        this.CommonsSessionStorageService.remove('availableDiscounts');
        this.CommonsSessionStorageService.remove('discountSelected');
        this.CommonsSessionStorageService.remove('deleteVoucher');
        this.CommonsSessionStorageService.remove('selectedLoggedCard');
        this.CommonsSessionStorageService.remove('selectedAviosDisccount');
        this.CommonsSessionStorageService.remove('flowId');
        this.CommonsSessionStorageService.remove('PNR');
        this.CommonsSessionStorageService.remove('userLogged');
        this.CommonsSessionStorageService.remove('segments');
        this.CommonsSessionStorageService.remove('passengers');
        this.CommonsSessionStorageService.remove('checkinSurname');
        this.CommonsSessionStorageService.remove('selectedIssuerCountry');
        this.CommonsSessionStorageService.remove('passengerBaggagesTrips');
        this.CommonsSessionStorageService.remove('specialMealsTempInfo');
        this.CommonsSessionStorageService.remove('flowApp');
        this.CommonsSessionStorageService.remove('frequentFlyersCompanies');
        this.CommonsSessionStorageService.remove('ancillariesInfo');
        this.CommonsSessionStorageService.remove('breakdownInfo');
        this.CommonsSessionStorageService.remove('pmtModelInfo');
        this.CommonsSessionStorageService.remove('paymentsInfo');
        this.CommonsSessionStorageService.remove('voucherInfo');
        this.CommonsSessionStorageService.remove('issueOrderInfo');
        this.CommonsSessionStorageService.remove('hasSelectedInsurance');
        this.CommonsSessionStorageService.remove('marketSaved');
        this.CommonsSessionStorageService.remove('currentSeatsInfo');
        this.CommonsSessionStorageService.remove('updateSeatLocal');
        this.CommonsSessionStorageService.remove('seatsSelectedInfoData');
        this.CommonsSessionStorageService.remove('updateSeatFlights');
        this.CommonsSessionStorageService.remove('ffLocal');
        this.CommonsSessionStorageService.remove('specialMealsTempInfoAux');
        this.CommonsSessionStorageService.remove('specialNeed');
        this.CommonsSessionStorageService.remove('modifyFFOrSpecialNeed');
        this.CommonsSessionStorageService.remove('specialMealsCopy');
        this.CommonsSessionStorageService.remove('segmentsAvailable');
        this.CommonsSessionStorageService.remove('mmbAncillariesPaymentSummaryModel');
        this.CommonsSessionStorageService.remove('showAlertFlexibilization');
        this.CommonsSessionStorageService.remove('typeDisruptionFlow');
        this.CommonsSessionStorageService.remove('commercialSellingData');
        this.CommonsSessionStorageService.remove('voucherOrderItems');
        this.CommonsSessionStorageService.remove('paymentRedirection');
        this.CommonsSessionStorageService.remove('hasPreorderAncillarie');
        this.CommonsSessionStorageService.remove('cashEmailNotification');
        this.CommonsSessionStorageService.remove('fareFamilyConditions');
        this.CommonsSessionStorageService.remove('summaryCVBounds');
        this.CommonsSessionStorageService.remove('flexibilityConditions');
        this.CommonsSessionStorageService.remove('fareFamilyConditionsConditions');
        this.CommonsSessionStorageService.remove('upgBidPutMade');
        this.CommonsSessionStorageService.remove('refundPercentage');
        this.CommonsSessionStorageService.remove('specialNeedsPassengers');
        this.CommonsSessionStorageService.remove('specialNeedsPassengersEdit');
        this.CommonsSessionStorageService.remove('deepLinkParams');
        this.CommonsSessionStorageService.remove('deepLinkData');
        this.CommonsSessionStorageService.remove('disruptionPeriodsInfo');
        this.CommonsSessionStorageService.remove('blackOutPeriodsData');
        this.CommonsSessionStorageService.remove('textBlackoutPeriods');
        this.CommonsSessionStorageService.remove('textAllowedPeriods');
        this.CommonsSessionStorageService.remove('allowedPeriods');
        this.CommonsSessionStorageService.remove('isCheckedAllPassengers');
        this.CommonsSessionStorageService.remove('selectedPriorityBoarding');
        this.CommonsSessionStorageService.remove('totalPricePriorityBoarding');
        this.CommonsSessionStorageService.remove('disruptionSeatChangeCapabilities');
        this.CommonsSessionStorageService.remove('paymentpassengerIdIBV');
        this.CommonsSessionStorageService.remove('pnrChannel');
        this.CommonsSessionStorageService.remove('unifiedNotIberiaOP');
        this.CommonsSessionStorageService.remove('isUnifiedFlow');
        this.CommonsSessionStorageService.remove('unifiedOfferType');
        this.CommonsSessionStorageService.remove('unifiedOptionalData');
        this.CommonsSessionStorageService.remove('warningDowngradeSameFlightAndTime');
        this.CommonsSessionStorageService.remove('warningDowngradeDiffFlightOrTime');
        this.CommonsSessionStorageService.remove('downgradeSlice');
        this.CommonsSessionStorageService.remove('downgradeCodes');
        this.CommonsSessionStorageService.remove('retrieveReservation');
        this.CommonsSessionStorageService.remove('waitingListPurchased');
        this.CommonsSessionStorageService.remove('confirmationDatalayerInfo');
        this.CommonsSessionStorageService.remove('confirmationDigitalInfo');
        this.CommonsSessionStorageService.remove('invoiceList');
        this.CommonsSessionStorageService.remove('listInvoices');
        this.CommonsSessionStorageService.remove('newRequestInvoices');
        this.CommonsSessionStorageService.remove('newRequestInvoicesFailure');
        this.CommonsSessionStorageService.remove('sessionUpgradingBidsInfo');
        this.CommonsSessionStorageService.remove('totalAmountBids');
        this.CommonsSessionStorageService.remove('blockedContinueSection');
        this.CommonsSessionStorageService.remove('isRefreshCall');
        this.CommonsSessionStorageService.remove('urlBidFlow');
        this.CommonsSessionStorageService.remove('cashPriceInfo');
        this.CommonsSessionStorageService.remove('prioritySegmentPutRequest');
        this.CommonsSessionStorageService.remove('passengerSpeqsTrips');
        this.CommonsSessionStorageService.remove('pmtMthdsBidsTransformed');
        this.CommonsSessionStorageService.remove('ancillariesPutAfterUpgBids');
        this.CommonsSessionStorageService.remove('newSeatsMap');
        this.CommonsSessionStorageService.remove('oldSeatsConfig');
        this.CommonsSessionStorageService.remove('longHaulAircrafts');
        this.CommonsSessionStorageService.remove('seatMapTourAircrafts');
        this.CommonsSessionStorageService.remove('mealsInfo');
        this.CommonsSessionStorageService.remove('addToCart');
        this.CommonsSessionStorageService.remove('upgradingBidsSlicesInfoResult');
        sessionStorage.removeItem(this.MmBAppConstants.COOKIES.BOOKING_INFO);
        this.DatalayerUniqueKeysService.clear();
        if (!this.isUserLogged()) {
            this.CommonsSessionStorageService.remove('customerData');
        }
    };

    /**
     * Returns the market from url
     * @returns {string} - returns an string made from params
     */
    getParameterByName = (name, url) => {
        let regex;
        let results;
        if (!url) url = this.$window.location.href;
        name = name.replace(/([[\]\\])/g, '\\$&');
        regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi');
        results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return null;
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };


    /**
     * Return the company logo url in the project.
     * @param {String} companyCode -The company code
     * @returns {String} - the company logo url that matches with its company code in the data on localStorage
     */
    getCompanyLogo = (companyCode) => {
        let coIndex = 0, coFound = false, companiesLogos: any = this.CommonsSessionStorageService.get('airlinesLogoList') || [];
        let airlineLogo = {
            'companyURL': this.MmBAppConstants.iconsRoute + this.MmBAppConstants.airlinesLogoBaseRoute + 'logo_pos_generico.svg',
            'companyDisabledURL': this.MmBAppConstants.iconsRoute + this.MmBAppConstants.airlinesLogoBaseRoute + 'logo_desact_generico.svg'
        };
        if (companyCode) {
            while (!coFound && coIndex < companiesLogos.length) {
                if (companiesLogos[coIndex].iataCompanyCode === companyCode) {
                    coFound = true;
                    airlineLogo.companyURL = this.MmBAppConstants.iconsRoute + this.MmBAppConstants.airlinesLogoBaseRoute + companiesLogos[coIndex].url;
                    airlineLogo.companyDisabledURL = this.MmBAppConstants.iconsRoute + this.MmBAppConstants.airlinesLogoBaseRoute + companiesLogos[coIndex].url_dis;
                }
                coIndex++;
            }
        }
        return airlineLogo;
    };

    /**
     * Generates a well formed model object from the received segment information
     * @param {Object} serviceSegmentInfo - the retrieve order rest service information
     */
    getBasicSegmentInformation = (serviceSegmentInfo, sliceId) => {
        let auxSegment = {
            'id': serviceSegmentInfo.id,
            'type': serviceSegmentInfo.type,
            'flown': serviceSegmentInfo.flown,
            'ckiStatus': angular.copy(serviceSegmentInfo.ckiStatus),
            'departure': angular.copy(serviceSegmentInfo.departure),
            'departureCity': angular.copy(serviceSegmentInfo.departureCity),
            'departureDateTime': serviceSegmentInfo.departureDateTime,
            'transformedDepartureDate': serviceSegmentInfo.departureDateTime && this.$filter('DateFormatFilter')(serviceSegmentInfo.departureDateTime),
            'arrival': angular.copy(serviceSegmentInfo.arrival),
            'arrivalCity': angular.copy(serviceSegmentInfo.arrivalCity),
            'arrivalDateTime': serviceSegmentInfo.arrivalDateTime,
            'sliceId': sliceId,
            'transformedArrivalDate': serviceSegmentInfo.arrivalDateTime && this.$filter('DateFormatFilter')(serviceSegmentInfo.arrivalDateTime),
            'segment': serviceSegmentInfo.flight ? {
                'numberFlight': serviceSegmentInfo.flight.marketingCarrier && serviceSegmentInfo.flight.marketingFlightNumber && serviceSegmentInfo.flight.marketingCarrier.code ? serviceSegmentInfo.flight.marketingCarrier.code + serviceSegmentInfo.flight.marketingFlightNumber : serviceSegmentInfo.flight.operationalCarrier.code + serviceSegmentInfo.flight.operationalFlightNumber,
                'operatedBy': serviceSegmentInfo.flight.marketingCarrier.code !== serviceSegmentInfo.flight.operationalCarrier.code ? serviceSegmentInfo.flight.operationalCarrier.code : ''
            } : {},
            'cabinClass': angular.copy(serviceSegmentInfo.cabin)
        };
        angular.extend(auxSegment.segment, this.getCompanyLogo(serviceSegmentInfo.flight && serviceSegmentInfo.flight.operationalCarrier
            && serviceSegmentInfo.flight.operationalCarrier.code));
        return auxSegment;
    };

    /**
     * Return conditions of fareFamilyInfo
     * @param {Object} fareFamilyInfo Response of fareFamylyRest query
     * @return {Object} Conditions- Object with all conditions for diferents comercial codes
     */
    setFareFamilyConditions = (fareFamilyInfo) => {
        let conditions = this.CommonsSessionStorageService.get('fareFamilyConditions') || {};
        if (fareFamilyInfo.length > 0) {
            this.CommonsSessionStorageService.set('fareFamilyConditionsConditions', fareFamilyInfo);
        }
        fareFamilyInfo = fareFamilyInfo || [];
        for (let i = 0; i < fareFamilyInfo.length; i++) {
            if (!conditions[fareFamilyInfo[i].commercialCode]) {
                conditions[fareFamilyInfo[i].commercialCode] = fareFamilyInfo[i];
            }
        }
        this.CommonsSessionStorageService.set('fareFamilyConditions', conditions);
        return conditions;
    };

    /**
     * Opens the fare family conditions modal with the received template and options
     * @param {Object} event the event received
     * @param {Object} data Data for load in modal window
     */
    openFareFamilyConditionsModal = (event, data) => {
        let modelFareFamily = this.CommonsSessionStorageService.get('fareFamilyConditions')[data.fareFamily] || {};
        angular.extend(modelFareFamily, { 'idModal': MMBDatalayerConstants.DATALAYER_MODAL_ID.FARE_CONDITIONS });
        this.MmBModalService.showGenericModal(data.isBlocked, data.template, modelFareFamily).result.then(angular.noop, angular.noop);
    };

    /**
     * Returns the literal identifier for the error code received
     * @param {String} errorCode the error code to be translated
     */
    getOldManageAppErrorMessage = (errorCode) => {
        const messages = {
            '001': 'ERROR_OLD_MMB_001',
            '002': 'ERROR_OLD_MMB_002',
            '003': 'ERROR_OLD_MMB_003',
            '004': 'ERROR_OLD_MMB_004',
            '005': 'ERROR_OLD_MMB_005',
            '006': 'ERROR_OLD_MMB_006',
            '007': 'ERROR_OLD_MMB_007',
            '008': 'ERROR_OLD_MMB_008',
            '009': 'ERROR_OLD_MMB_009',
            '010': 'ERROR_OLD_MMB_010',
            '011': 'ERROR_OLD_MMB_011',
            '012': 'ERROR_OLD_MMB_012',
            '013': 'ERROR_OLD_MMB_013',
            '014': 'ERROR_OLD_MMB_014',
            '015': 'ERROR_OLD_MMB_015',
            '016': 'ERROR_OLD_MMB_016',
            '017': 'ERROR_OLD_MMB_017',
            '018': 'ERROR_OLD_MMB_018',
            '019': 'ERROR_OLD_MMB_019',
            '020': 'ERROR_OLD_MMB_020',
            '021': 'ERROR_OLD_MMB_021'
        };
        return messages[errorCode];
    };


    getRelatedContent = (relatedContent) => {
        let returnRelatedContent = {};
        if (relatedContent) {
            for (let i = 0; i < relatedContent.length; i++) {
                returnRelatedContent[relatedContent[i].key] = this.$sce.trustAsHtml(relatedContent[i].value);
            }
        }
        return returnRelatedContent;
    };


    /**
    * Return the background image in the project.
    * @param {String} destinationCityCode -The destination city code
    * @returns {String} - the background image url that matches with its destination city code in the data on localStorage
    */
    getBackGroundURL = (destinationCityCode) => {
        let imageResolution = this.$window.innerWidth > 1024 ?
            this.MmBAppConstants.DESTINATION_IMAGE_SIZE.desktop :
            (this.$window.innerWidth > 480 && this.$window.innerWidth < 1024) ?
                this.MmBAppConstants.DESTINATION_IMAGE_SIZE.tablet :
                this.$window.innerWidth < 481 ?
                    this.MmBAppConstants.DESTINATION_IMAGE_SIZE.mobile :
                    this.MmBAppConstants.DESTINATION_IMAGE_SIZE.desktop;
        const backgroundURL = this.$window.location.origin + '/wcs/imagenes/destinos/calculadoraAvios/' + destinationCityCode.toUpperCase() + imageResolution;

        return backgroundURL;
    };

    /**
     * Retrieve the formatted date based on the current language
     * @param {*} date Parameter that collects the filter date
     * @param {*} format Parameter that collects the format of the filter that must be recovered from the locals
     * When the 'iberia-web-content/locales/locale_*.js' has the correct format, we have to change the 'MmBAppConstants' by the call to 'CommonsSessionStorageService' to get the 'commercialInfo' => constantData = this.CommonsSessionStorageService.get('commercialInfo')
     * dateFormatByLanguage = commercialData.languages[languageIndex].dateFormat[format]
     */
    getFormatedDate = (date, format) => {
        let language = this.$rootScope.appLang, constantsData = this.MmBAppConstants, formatedDate = null;
        let foundedLanguage = false, languageIndex = 0, dateFormatByLanguage = null;
        if (language && constantsData && constantsData.FORMAT_DATE) {
            while (!foundedLanguage && languageIndex < constantsData.FORMAT_DATE.length) {
                if (constantsData.FORMAT_DATE[languageIndex].code === language.toLowerCase()) {
                    dateFormatByLanguage = constantsData.FORMAT_DATE[languageIndex].dateFormat[format];
                    foundedLanguage = true;
                }
                languageIndex++;
            }
            formatedDate = foundedLanguage && dateFormatByLanguage ? dayjs(date).format(dateFormatByLanguage) : dayjs(date).format(constantsData.FORMAT_DATE[0].dateFormat.gaDate);
        } else {
            formatedDate = dayjs(date).format('L');
        }
        return { 'formatedDate': formatedDate, 'dateFormatByLanguage': dateFormatByLanguage };
    };

    ////////////////
    /**
     * Returns if screen type is mobile or not depending on screen size.
     * @returns {Boolean} - returns a boolean.
     */
    isMobile = () => {
        let isMobile = this.$rootScope.isMobile ||
        { 'general': this.$window.innerWidth < 768, 'header': this.$window.innerWidth < 1024 };
        angular.element(this.$window).on('resize', () => {
            this.$rootScope.isMobile = { 'general': this.$window.innerWidth < 768, 'header': this.$window.innerWidth < 1024 };
        });
        return isMobile;
    };


    /**
     * Return the company logo url in the project.
     * @param {String} companyCode -The company code
     * @returns {String} - the company logo url that matches with its company code in the data on localStorage
     */
    getCompanyURL = (companyCode) => {
        let airlinesLogo: any = this.CommonsSessionStorageService.get('airlinesLogoList') || [], i = 0, found = false, companyURL = '';
        while (!found && i < airlinesLogo.length) {
            if (airlinesLogo[i].iataCompanyCode === companyCode) {
                found = true;
                companyURL = this.MmBAppConstants.airlinesLogoBaseRoute + airlinesLogo[i].url;
            }
            i++;
        }
        if (!found) {
            companyURL = this.MmBAppConstants.airlinesLogoBaseRoute + this.MmBAppConstants.defaultAirlineLogo;
        }
        return companyURL;
    };

    /**
     * Returns the value of the first param found
     * @param  {Array<String>} paramsName - An array with the possible names of an URL param
     * @returns {String} - The value of the first param found in the array
     */
    getURLFirstParameterByName = (paramsName) => {
        let paramValue = null, i = 0;
        if (angular.isArray(paramsName)) {
            while (paramValue == null && i < paramsName.length) {
                if (angular.isString(paramsName[i])) {
                    paramValue = this.getParameterByName(paramsName[i], null);
                }
                i++;
            }
        } else if (angular.isString(paramsName)) {
            paramValue = this.getParameterByName(paramsName, null);
        }
        return paramValue;
    };

    getPathParameterByName = (name) => {
        let regex, results, url = this.$location.path();
        name = name.replace(/([[\]\\])/g, '\\$&');
        regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi');
        results = regex.exec(url);
        return results && results[2] ? results[2]: null;
    };

    getEndpoint = (key) => {
        return (this.CommonsSessionStorageService.get('endpoints') || {})[key];
    };

    /**
    * This functions get the loged codified token and return user name  decodified.
    * This is neccesary for call service and get information user.
    *  @returns {String} userName of user logged.
    *  */
    getMemberIdByToken = () => {
        let infoToken = null, resultJsonToken = null, accessToken: any = this.CommonsSessionStorageService.get('loggedToken') || null;
        if (accessToken) {
            accessToken = accessToken.split('.')[1];
            infoToken = decodeURIComponent(window.atob(accessToken));
            resultJsonToken = JSON.parse(infoToken);
        }
        return resultJsonToken && resultJsonToken.preferred_username ? resultJsonToken.preferred_username : null;
    };

    /**
     * Given the array, creates an object that has one property for each kind of parameter found in the array
     * @param {*} array initial array to be transformed
     * @param {*} parameter string that defines which property of each element we will use to create the new object
     * @param {*} canBeRepeated boolean that tells if each parameter can have more than one element of the initial array.
     * @returns {*} transformedObject
     */
    getElementsByProperty = (array, parameter, canBeRepeated) => {
        let transformedObject = {};
        if (canBeRepeated) {
            for (let i = 0; i < array.length; i++) {
                transformedObject[array[i][parameter]] = transformedObject[array[i][parameter]] || [];
                transformedObject[array[i][parameter]].push(array[i]);
            }
        } else {
            for (let i = 0; i < array.length; i++) {
                transformedObject[array[i][parameter]] = array[i];
            }
        }
        return transformedObject;
    };

    ////////////////

    /**
     * Return url to show backgrond payment while loading payment
     */
    getPaymentsBackGroundURL = () => {
        let backgroundURL, widthScreen = this.$window.innerWidth > 1024 ? 2000 : (this.$window.innerWidth > 480 && this.$window.innerWidth < 1025) ? 768 : this.$window.innerWidth < 481 ? 320 : 2000;
        backgroundURL = '/background/generico/disponibilidad_default_' + widthScreen + '.jpg';
        return backgroundURL;
    };

    /**
     * Generate infoheader object, save in localStorage and return it
     * @param {Array} segments Information of segments
     * @param {Array} passengers  Information of passengers
     */
    getInfoHeader = (segments, passengers) => {
        const originCityInfo = (departure) => {
            return {
                'code': departure.airportCode,
                'description': departure.airportCode,
                'timezone': '',
                'country': {
                    'code': '',
                    'description': ''
                }
            };
        };
        const destinationCityInfo = (arrival) => {
            return {
                'code': arrival.airportCode,
                'description': arrival.airportCode,
                'timezone': '',
                'country': {
                    'code': '',
                    'description': ''
                }
            };
        };
        const dateFlightInfo = (departure) => {
            return {
                'outboundFlight': this.getMiddleDashDate(departure.date),
                'formatedOutboundFlight': this.getMiddleDashDate(departure.date) + 'T00:00:00.000Z',
                'returnFlight': '',
                'formatedReturnFlight': ''
            };
        };

        let modelHeader = [],
            segmentInfo: any = {};
        this.getSegmentsInfo(segments);

        segments.forEach((segment) => {
            segmentInfo = {
                'originCity': {},
                'destinationCity': {},
                'dates': {},
                'passengers': 0,
                'numAdults': 0,
                'numSeniors': 0,
                'numYoung': 0,
                'numTeenager': 0,
                'numInfant': 0,
                'numChilds': 0,
                'numberPassengrsWithoutInfant': 0
            };
            segmentInfo.originCity = originCityInfo(segment.departure);
            segmentInfo.destinationCity = destinationCityInfo(segment.arrival);
            segmentInfo.dates = dateFlightInfo(segment.departure);
            passengers.forEach((passenger) => {
                switch (passenger.type) {
                        case this.MmBAppConstants.PASSENGER_TYPE.SENIOR:
                            segmentInfo.numSeniors += 1;
                            break;
                        case this.MmBAppConstants.PASSENGER_TYPE.ADULT:
                            segmentInfo.numAdults += 1;
                            break;
                        case this.MmBAppConstants.PASSENGER_TYPE.CHILD:
                            segmentInfo.numChilds += 1;
                            break;
                        case this.MmBAppConstants.PASSENGER_TYPE.INFANT:
                            segmentInfo.numInfant += 1;
                            break;
                        case this.MmBAppConstants.PASSENGER_TYPE.YOUTH:
                            segmentInfo.numYoung += 1;
                            break;
                }
                if (passenger.infant === null) {
                    segmentInfo.numberPassengrsWithoutInfant += 1;
                }
            });
            segmentInfo.passengers = passengers.length;
            modelHeader.push(segmentInfo);
        });
        return modelHeader;
    };

    /**
    * Return segments on booking
    * @return {Array} List of segments on booking with basic information
    */
    getSegmentsInfo = (segmentsInfo) => {
        var i, segments: any = this.CommonsSessionStorageService.get('segmentsInfo') || [], segment;

        for (i = 0; i < segmentsInfo.length; i++) {
            segment = {
                'id': segmentsInfo[i].segmentId,
                'origin': {
                    'description': segmentsInfo[i].departure.city.description,
                    'code': segmentsInfo[i].departure.city.code
                },
                'destination': {
                    'description': segmentsInfo[i].arrival.city.description,
                    'code': segmentsInfo[i].arrival.city.code
                }
            };
            segments.push(segment);
        }

        return segments;
    };


    getTypeAndDescription = (features) => {
        var seat = { 'type': null, 'description': null };

        if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.EMERGENCY_EXIT) !== -1) {
            seat.type = this.MmBAppConstants.SEAT_FEATURE.EMERGENCY_EXIT;
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.EMERGENCY_EXIT) === -1 && features.indexOf(this.MmBAppConstants.SEAT_FEATURE.EXTRA_SIZE) !== -1) {
            seat.type = this.MmBAppConstants.SEAT_FEATURE.EXTRA_SIZE;
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.EMERGENCY_WINDOW) !== -1 && features.indexOf(this.MmBAppConstants.SEAT_FEATURE.EXTRA_SIZE) === -1) {
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.INFANT) !== -1) {
            seat.type = this.MmBAppConstants.SEAT_FEATURE.INFANT;
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.PROMO) !== -1) {
            seat.type = this.MmBAppConstants.SEAT_FEATURE.PROMO;
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.PROMO) !== -1 && features.indexOf(this.MmBAppConstants.SEAT_FEATURE.INFANT) !== -1) {
            seat.type = this.MmBAppConstants.SEAT_FEATURE.INFANT;
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.UPFRONT) !== -1) {
            seat.type = this.MmBAppConstants.SEAT_FEATURE.UPFRONT;
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.MOBILITY) !== -1) {
            seat.type = this.MmBAppConstants.SEAT_FEATURE.MOBILITY;
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.SCREEN) !== -1) {
            seat.type = '';
        } if (features.indexOf(this.MmBAppConstants.SEAT_FEATURE.NON_RECLINING) !== -1) {
            seat.type = '';
        }

        switch (seat.type) {
                case this.MmBAppConstants.SEAT_FEATURE.EMERGENCY_EXIT: seat.description = this.$filter('translate')('CKIANCSEATS_SEAT_EMERGENCY_XL'); break;
                case this.MmBAppConstants.SEAT_FEATURE.EXTRA_SIZE: seat.description = this.$filter('translate')('SEATS_EXTRA_SIZE_SEAT'); break;
                case this.MmBAppConstants.SEAT_FEATURE.PROMO: seat.description = this.$filter('translate')('SEATS_SEAT_PROMO'); break;
                case this.MmBAppConstants.SEAT_FEATURE.INFANT: seat.description = this.$filter('translate')('CKIANCSEATS_SEAT_INFANT'); break;
                case this.MmBAppConstants.SEAT_FEATURE.MOBILITY: seat.description = this.$filter('translate')('CKIANCSEATS_SEAT_HANDICAP'); break;
                case this.MmBAppConstants.SEAT_FEATURE.UPFRONT: seat.description = this.$filter('translate')('CKIANCSEATS_SEAT_UPFRONT'); break;
                default: seat.description = ''; break;
        }

        return seat;
    };

    /**
     * Generate information of ancillaries for common header
     * @param {Object} breakDownInfo Information recovered by basket service
     * @return {Object} basket
     */
    generateAncillariesHeaderInfo = (breakDownInfo, segmentsInfo) => {
        const addNewSeat = (segment, passengerInfo) => {
            let i = 0, isFound = false, seatType: any = {}, seatInfo;
            if (passengerInfo.seat.features.length > 0) {
                seatInfo = this.getTypeAndDescription(passengerInfo.seat.features);
            } else {
                seatInfo = { 'type': '', 'description': '' };
            }

            while (i < segment.seats.length && !isFound) {
                if (segment.seats[i].type === seatInfo.type) {
                    segment.seats[i].passengers.push({ 'id': passengerInfo.id, 'amount': passengerInfo.amount });
                    segment.seats[i].quanty++;
                    segment.seats[i].amount += passengerInfo.amount;
                    segment.seats[i].totalFormatted = this.CurrencyService.formatPrice(basket.currency, segment.seats[i].amount, true, false);
                    trip.quanty++;
                    trip.total += passengerInfo.amount;
                    isFound = true;
                }
                i++;
            }

            if (!isFound) {
                seatType = { 'quanty': 1, passengers: [], 'amount': 0, 'totalFormatted': null };
                angular.extend(seatType, seatInfo);
                seatType.amount += passengerInfo.amount;
                seatType.totalFormatted = this.CurrencyService.formatPrice(basket.currency, seatType.amount, true, false);
                seatType.passengers.push({ 'id': passengerInfo.id, 'amount': passengerInfo.amount });
                trip.total += seatType.amount;
                trip.quanty++;
                segment.seats.push(seatType);
            }
        };




        const getOriginAndDestination = (trips, segmentsInfo) => {
            let j, isFound: boolean;
            for (let i = 0; i < trips.length; i++) {
                j = 0; isFound = false;
                while (!isFound && j < segmentsInfo.length) {
                    if (trips[i].segmentId === segmentsInfo[j].segmentId) {
                        trips[i].origin = segmentsInfo[j].departure.city;
                        trips[i].destination = segmentsInfo[j].arrival.city;
                        isFound = true;
                    }
                    j++;
                }
            }
        };

        const getCurrencyAncillarie = (summaryCurrencies, ancillarie) => {
            var i = 0, isFound = false, currency;

            while (!isFound || i < summaryCurrencies.length) {
                if (summaryCurrencies[i].code === ancillarie.currency) {
                    currency = summaryCurrencies[i];
                    isFound = true;
                }
                i++;
            }
            return currency;
        };

        var basket = { 'baggages': [], 'speqs': [], 'seats': [], 'insurance': null, 'upgrading': { 'upgradingTrips': [], 'total': null, 'totalFormatted': null }, 'currency': null }, k,
            trip, passenger, isFound = false, tripBaggage, tripSpeq;
        const bookingInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
        var currencyInfo = breakDownInfo.currencies ? breakDownInfo.currencies : bookingInfo.contextMetadata.currencies.length > 0 ? bookingInfo.contextMetadata.currencies : null;

        if (breakDownInfo.pendingPaymentItems.length > 0) {
            basket.currency = this.CurrencyService.getCurrencyObject(getCurrencyAncillarie(breakDownInfo.currencies, breakDownInfo.pendingPaymentItems[0]));
        } else {
            basket.currency = this.CurrencyService.getCurrencyObject(currencyInfo);
        }

        for (let i = 0; i < breakDownInfo.pendingPaymentItems.length; i++) {
            switch (breakDownInfo.pendingPaymentItems[i].type) {
                    case this.MmBAppConstants.ANCILLARIES_TYPES.SEAT:
                        angular.forEach(breakDownInfo.pendingPaymentItems[i].segments, (segment) => {
                            trip = { 'segmentId': null, 'seats': [], 'origin': null, 'destination': null, 'quanty': 0, 'total': 0, 'totalFormatted': 0 };
                            trip.segmentId = segment.id;
                            angular.forEach(segment.passengers, (passenger) => {
                                addNewSeat(trip, passenger);
                                trip.quanty += 1;
                            });
                            trip.totalFormatted = this.CurrencyService.formatPrice(basket.currency, trip.total, true, false);
                            basket.seats.push(trip);
                        });
                        getOriginAndDestination(basket.seats, segmentsInfo);

                        break;

                    case this.MmBAppConstants.ANCILLARIES_TYPES.INSURANCE:
                        basket.insurance = {
                            'offer': breakDownInfo.pendingPaymentItems[i].offer,
                            'total': breakDownInfo.pendingPaymentItems[i].total,
                            'totalFormatted': this.CurrencyService.formatPrice(basket.currency, breakDownInfo.pendingPaymentItems[i].total, true, false),
                            'passengers': 1,
                            'type': 'Anulaci�n + Asistencia'
                        };
                        break;

                    case this.MmBAppConstants.ANCILLARIES_TYPES.UPGRADING:
                        angular.forEach(breakDownInfo.pendingPaymentItems[i].upgrading.offerSegmentsClass, (segment) => {
                            trip = { 'segmentId': segment.segmentId, 'cabin': segment.cabinClass.description, 'origin': null, 'destination': null };
                            basket.upgrading.upgradingTrips.push(trip);
                        });
                        basket.upgrading.total = breakDownInfo.pendingPaymentItems[i].total;
                        basket.upgrading.totalFormatted = this.CurrencyService.formatPrice(basket.currency, basket.upgrading.total, true, false);

                        getOriginAndDestination(basket.upgrading.upgradingTrips, segmentsInfo);
                        break;


                    case this.MmBAppConstants.ANCILLARIES_TYPES.BAGGAGE:
                        angular.forEach(breakDownInfo.pendingPaymentItems[i].slices, (slice)=>  {
                            isFound = false;
                            tripBaggage = { 'segmentId': slice.id, 'baggages': [], 'total': slice.total };

                            angular.forEach(slice.passengers, (passenger) => {
                                angular.forEach(passenger.pieces, (piece) => {
                                    if (tripBaggage.baggages.length > 0) {
                                        for (let j = 0; j < tripBaggage.baggages.length; j++) {
                                            if (tripBaggage.baggages[j].type === piece.subtype) {
                                                tripBaggage.baggages[j].quanty += piece.quantity;
                                                tripBaggage.baggages[j].total += piece.total;
                                                tripBaggage.baggages[j].totalFormatted = this.CurrencyService.formatPrice(basket.currency, tripBaggage.baggages[j].total, true, false);
                                                tripBaggage.baggages[j].passengers.push(passenger.id);
                                                isFound = true;
                                            }
                                        }
                                    }
                                    if (!isFound || tripBaggage.baggages.length < 1) {
                                        tripBaggage.baggages.push({ 'type': piece.subtype, 'quanty': piece.quantity, 'description': piece.description, 'total': piece.total, 'totalFormatted': this.CurrencyService.formatPrice(basket.currency, piece.total, true, false), 'passengers': [passenger.id] });
                                    }
                                });
                            });
                            basket.baggages.push(tripBaggage);
                        });
                        getOriginAndDestination(basket.baggages, segmentsInfo);
                        break;

                    case this.MmBAppConstants.ANCILLARIES_TYPES.SPEQS:
                        angular.forEach(breakDownInfo.pendingPaymentItems[i].slices, (slice) => {
                            isFound = false;
                            tripSpeq = { 'segmentId': slice.id, 'speqs': [], 'total': slice.total };

                            angular.forEach(slice.passengers, (passenger) => {
                                angular.forEach(passenger.pieces, (piece) => {
                                    if (tripSpeq.speqs.length > 0) {
                                        for (let j = 0; j < tripSpeq.speqs.length; j++) {
                                            if (tripSpeq.speqs[j].type === piece.subtype) {
                                                tripSpeq.speqs[j].quanty += piece.quantity;
                                                tripSpeq.speqs[j].total += piece.total;
                                                tripSpeq.speqs[j].totalFormatted = this.CurrencyService.formatPrice(basket.currency, tripSpeq.speqs[j].total, true, false);
                                                tripSpeq.speqs[j].passengers.push(passenger.id);
                                                isFound = true;
                                            }
                                        }
                                    }
                                    if (!isFound || tripSpeq.speqs.length < 1) {
                                        tripSpeq.speqs.push({ 'type': piece.subtype, 'quanty': piece.quantity, 'description': piece.description, 'total': piece.total, 'totalFormatted': this.CurrencyService.formatPrice(basket.currency, piece.total, true, false), 'passengers': [passenger.id] });
                                    }
                                });
                            });
                            basket.speqs.push(tripSpeq);
                        });
                        getOriginAndDestination(basket.speqs, segmentsInfo);
                        break;

            }
        }

        return basket;
    };

    /**
     * Return array with description of failed items delete
     * @param {Array} cancelData
     */
    checkFailedPendingPayments = (cancelData) => {
        let returnedFailedItems = '';
        if (cancelData != null && cancelData.failedToDelete) {
            for (let i = 0; i < cancelData.failedToDelete.length; i++) {
                if (cancelData.failedToDelete[i].type === this.MmBAppConstants.ANCILLARIES_TYPES.SEAT) {
                    for (let j = 0; j < cancelData.failedToDelete[i].segments.length; j++) {
                        returnedFailedItems += cancelData.failedToDelete[i].segments[j].error.description;
                    }
                } else if (cancelData.failedToDelete[i].type === this.MmBAppConstants.ANCILLARIES_TYPES.BAGGAGE) {
                    for (let j = 0; j < cancelData.failedToDelete[i].segments.length; j++) {
                        returnedFailedItems += cancelData.failedToDelete[i].pasengers[j].error.description;
                    }
                } else if (cancelData.failedToDelete[i].type === this.MmBAppConstants.ANCILLARIES_TYPES.UPGRADING) {
                    returnedFailedItems += cancelData.failedToDelete[i].error.description;
                }
            }
        }
        return returnedFailedItems;
    };

    /**
     * Emits event for close header basket collapse
     */
    closeBasketHeader = () => {
        this.$rootScope.$broadcast('closeCollapseHeader');
    };

    /**
     * Generate segments information and save in localstorage
     * @param {Array} fligthsInfo Flights information
     */
    generateSegmentsInfo = (fligthsInfo) => {
        let segments = [], segment;

        for (let i = 0; i < fligthsInfo.length; i++) {
            segment = {
                'id': fligthsInfo[i].segmentId,
                'origin': {
                    'description': fligthsInfo[i].departureCity.city.description,
                    'code': fligthsInfo[i].departureCity.city.code
                },
                'destination': {
                    'description': fligthsInfo[i].arrivalCity.city.description,
                    'code': fligthsInfo[i].arrivalCity.city.code
                }
            };
            segments.push(segment);
        }
        return segments;
    };


    generateVoucherSummaryModel = (orderItems, slicesModel, currency) => {
        const generateInfo = () => {
            const generatePassengerInfo = (passenger) => {
                const addNewPas = (pas) => {
                    returnInfo.passengersInfo.push({
                        'type': pas.passengerId.slice(0, pas.passengerId.length - 3),
                        'typePlural': 'SOME_' + pas.passengerId.slice(0, pas.passengerId.length - 3),
                        'amount': 1,
                        'farePrice': pas.price.fare,
                        'farePriceFormatted': this.CurrencyService.formatPrice(currency, pas.price.fare, true, false),
                        'taxPrice': pas.price.tax,
                        'taxPriceFormatted': this.CurrencyService.formatPrice(currency, pas.price.tax, true, false),
                        'totalPrice': pas.price.total,
                        'totalPriceFormatted': this.CurrencyService.formatPrice(currency, pas.price.total, true, false)
                    });
                };

                let i = 0, isFound = false;
                angular.forEach(passenger.passengerPrices, (pas) => {
                    i = 0, isFound = false;
                    if (pas.price) {
                        if (returnInfo.passengersInfo.length > 0) {
                            while (!isFound && i < returnInfo.passengersInfo.length) {
                                if (returnInfo.passengersInfo[i].type === pas.passengerId.slice(0, pas.passengerId.length - 3) && returnInfo.passengersInfo[i].farePrice === pas.price.fare) {
                                    isFound = true;
                                    returnInfo.passengersInfo[i].amount++;
                                    returnInfo.passengersInfo[i].totalPrice += pas.price.total;
                                    returnInfo.passengersInfo[i].totalPriceFormatted = this.CurrencyService.formatPrice(currency, returnInfo.passengersInfo[i].totalPrice, true, false);
                                }
                                i++;
                            }
                            if (!isFound) {
                                addNewPas(pas);
                            }
                        } else {
                            addNewPas(pas);
                        }
                    }
                });
            };

            const generateBaggageInfo = (baggage) => {
                const addNewBaggage = (slice, baggage) => {
                    slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.BAGGAGE, 'price': baggage.price.fare, 'unitaryPrice': baggage.price.fare / baggage.amount, 'amount': baggage.amount, 'priceFormatted': this.CurrencyService.formatPrice(currency, baggage.price.fare / baggage.amount, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(currency, baggage.price.fare, true, false) });
                    slice.hasBaggage = true;
                };

                var i = 0, isFound = false;
                angular.forEach(slicesInfo, (slice) => {
                    if (slice.sliceId === baggage.sliceId) {
                        i = 0, isFound = false;
                        if (slice.ancillaries.length > 0) {
                            while (!isFound && i < slice.ancillaries.length) {
                                if (slice.ancillaries[i].type === this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.BAGGAGE && (slice.ancillaries[i].unitaryPrice === baggage.price.fare / baggage.amount || slice.ancillaries[i].price === baggage.price.fare)) {
                                    isFound = true;
                                    slice.ancillaries[i].amount += baggage.amount;
                                    slice.ancillaries[i].price += baggage.price.fare;
                                    slice.ancillaries[i].priceTotalFormatted = this.CurrencyService.formatPrice(currency, slice.ancillaries[i].price, true, false);
                                }
                                i++;
                            }
                            if (!isFound) {
                                addNewBaggage(slice, baggage);
                            }
                        } else {
                            slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.BAGGAGE, 'price': baggage.price.fare, 'unitaryPrice': baggage.price.fare / baggage.amount, 'amount': baggage.amount, 'priceFormatted': this.CurrencyService.formatPrice(currency, baggage.price.fare / baggage.amount, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(currency, baggage.price.fare, true, false) });
                            slice.hasBaggage = true;
                        }
                    }
                });
            };

            const generateSeatsInfo = (seat) => {
                const addNewSeat = (slice, seat, segmentSlice) => {
                    slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SEAT, 'price': seat.price.fare, 'amount': 1, 'priceFormatted': this.CurrencyService.formatPrice(currency, seat.price.fare, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(currency, seat.price.fare, true, false), 'segmentId': segmentSlice.id });
                    slice.hasSeat = true;
                };

                let i = 0, isFound = false;
                angular.forEach(slicesInfo, (slice) => {
                    angular.forEach(slice.segments, (segmentSlice) => {
                        if (segmentSlice.id === seat.segmentId) {
                            i = 0, isFound = false;
                            segmentSlice.hasSeat = true;
                            if (slice.ancillaries.length > 0) {
                                while (!isFound && i < slice.ancillaries.length) {
                                    if (slice.ancillaries[i].type === this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SEAT && slice.ancillaries[i].price === seat.price.fare && slice.ancillaries[i].segmentId === seat.segmentId) {
                                        isFound = true;
                                        slice.ancillaries[i].amount++;
                                        slice.ancillaries[i].priceTotalFormatted = this.CurrencyService.formatPrice(currency, slice.ancillaries[i].amount * slice.ancillaries[i].price, true, false);
                                    }
                                    i++;
                                }
                                if (!isFound) {
                                    addNewSeat(slice, seat, segmentSlice);
                                }
                            } else {
                                slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SEAT, 'price': seat.price.fare, 'amount': 1, 'priceFormatted': this.CurrencyService.formatPrice(currency, seat.price.fare, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(currency, seat.price.fare, true, false), 'segmentId': segmentSlice.id });
                                slice.hasSeat = true;
                            }
                        }
                    });
                });
            };

            angular.forEach(orderItems, (item) => {
                if (item.price && item.price.fare >= 0) {
                    switch (item.type) {
                            case 'flight':
                                generatePassengerInfo(item);
                                returnInfo.totalPrice.total += item.price.total ? item.price.total : 0;
                                break;

                            case 'baggage':
                                generateBaggageInfo(item);
                                returnInfo.totalPrice.total += item.price.fare ? item.price.fare : item.price.total ? item.price.total : 0;
                                returnInfo.hasBaggage = true;
                                break;

                            case 'seat':
                                generateSeatsInfo(item);
                                returnInfo.totalPrice.total += item.price.fare ? item.price.fare : item.price.total ? item.price.total : 0;
                                returnInfo.hasSeat = true;
                                break;
                    }
                }
            });
        };

        const generateSlicesInfo = () => {
            let slices = [], i, segmentList, sliceOrigin, sliceDestination;
            angular.forEach(slicesModel, (slice) => {
                segmentList = [];
                angular.forEach(slice.segments, (segmentSlice) => {
                    for (i = 0; i < segmentsInfo.length; i++) {
                        if (segmentSlice.id === segmentsInfo[i].id) {
                            segmentList.push(segmentsInfo[i]);
                        }
                        if (i === 0) sliceOrigin = segmentSlice.departure.city;
                        sliceDestination = segmentSlice.arrival.city;
                    }
                });
                slices.push({ 'sliceId': slice.sliceId, 'segments': segmentList, 'ancillaries': [], 'hasBaggage': false, 'hasSeat': false, 'sliceOrigin': sliceOrigin, 'sliceDestination': sliceDestination });
            });
            return slices;
        };

        var segmentsInfo = [], slicesInfo, currency, returnInfo = { 'passengersInfo': [], 'slicesInfo': null, 'hasBaggage': false, 'hasSeat': false, 'totalPrice': { 'totalPriceFormmated': '', 'total': 0 } };

        angular.forEach(slicesModel, (slice) => {
            angular.forEach(slice.segments, (segment) => {
                segmentsInfo.push({
                    'id': segment.id,
                    'origin': segment.departureCity,
                    'destination': segment.arrivalCity
                });
            });
        });
        slicesInfo = generateSlicesInfo();
        generateInfo();

        returnInfo.slicesInfo = slicesInfo;
        returnInfo.totalPrice.totalPriceFormmated = this.CurrencyService.formatPrice(currency, returnInfo.totalPrice.total, true, false);
        return returnInfo;
    };



    getPriceGlobick = () => {
        const voucherItems = this.CommonsSessionStorageService.get('voucherOrderItems');
        if (voucherItems !== null) {
            for (let i=0; i<voucherItems.length; i++){
                if (voucherItems[i].type === 'globickV2' || voucherItems[i].type === 'globick'){
                    return voucherItems[i].price.fare;
                }
            }
        }
        return 0;
    };

    transformVoucherPriceInfo = (voucherPriceInfo, currenciesList, isPartialRefund, totalPrice) => {
        var formattedVoucherPriceInfo: any = {
                'price': 0,
                'formattedPrice': '',
                'priceWOPercentage': 0,
                'priceWOPercentageFormatted': '',
                'percentagePrice': 0,
                'percentagePriceFormatted': 0,
                'percentage': '',
                'currency': '',
                'isPartialRefund': isPartialRefund,
                'totalPriceFare': 0,
                'totalPriceTax': 0,
                'totalPriceTotal': 0,
                'totalPriceTotalFormatted': ''
            }, currencyFound = false, currencyIndex = 0, currencyObject: any = {};

        formattedVoucherPriceInfo.price = voucherPriceInfo.totalRefund;
        formattedVoucherPriceInfo.currency = voucherPriceInfo.currency;
        formattedVoucherPriceInfo.priceWOPercentage = voucherPriceInfo.fare;
        formattedVoucherPriceInfo.percentagePrice = voucherPriceInfo.extraVoucherAmount;
        formattedVoucherPriceInfo.percentage = voucherPriceInfo.extraVoucherPercent !== 0 ? voucherPriceInfo.extraVoucherPercent + '%' : angular.noop;
        this.CommonsSessionStorageService.set('voucherPartialRefund', isPartialRefund);

        while (!currencyFound && currencyIndex < currenciesList.length) {
            if (voucherPriceInfo.currency === currenciesList[currencyIndex].code) {
                currencyFound = true;
                currencyObject = currenciesList[currencyIndex];
            } else
                currencyIndex++;
        }
        formattedVoucherPriceInfo.formattedPrice = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), voucherPriceInfo.totalRefund, true, false);
        formattedVoucherPriceInfo.priceWOPercentageFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), voucherPriceInfo.fare, true, false);
        formattedVoucherPriceInfo.percentagePriceFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), voucherPriceInfo.extraVoucherAmount, true, false);

        const totalPriceGlobick = this.getPriceGlobick();

        if (totalPrice &&  totalPriceGlobick === 0) {
            formattedVoucherPriceInfo.totalPriceFare = totalPrice.fare;
            formattedVoucherPriceInfo.totalPriceTax = totalPrice.tax;
            formattedVoucherPriceInfo.totalPriceTotal = totalPrice.total;
            formattedVoucherPriceInfo.totalPriceTotalFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), totalPrice.total, true, false);
        } else if (totalPrice &&  totalPriceGlobick !== 0){
            formattedVoucherPriceInfo.totalPriceFare = totalPrice.fare - totalPriceGlobick;
            formattedVoucherPriceInfo.totalPriceTax = totalPrice.tax;
            formattedVoucherPriceInfo.totalPriceTotal = totalPrice.total - totalPriceGlobick;
            formattedVoucherPriceInfo.totalPriceTotalFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), formattedVoucherPriceInfo.totalPriceTotal, true, false);
        }

        this.CommonsSessionStorageService.set('voucherPriceInfo', formattedVoucherPriceInfo);
    };

    transformCashPriceInfo = (cashPricesInfo, currenciesList) => {
        var cashPriceIndex, currencyFound, currencyIndex, cashPricesInfoList = [], currencyObject: any = {};

        for (cashPriceIndex = 0; cashPriceIndex < cashPricesInfo.length; cashPriceIndex++) {
            var formattedCashPriceInfo = {
                'price': 0,
                'formattedPrice': ''
            };
            currencyFound = false, currencyIndex = 0;

            formattedCashPriceInfo.price = cashPricesInfo[cashPriceIndex].amount;
            while (!currencyFound && currencyIndex < currenciesList.length) {
                if (cashPricesInfo[cashPriceIndex].currency === currenciesList[currencyIndex].code) {
                    currencyFound = true;
                    currencyObject = currenciesList[currencyIndex];
                } else
                    currencyIndex++;
            }
            formattedCashPriceInfo.formattedPrice = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), cashPricesInfo[cashPriceIndex].amount, true, false);

            cashPricesInfoList.push(formattedCashPriceInfo);
        }

        this.CommonsSessionStorageService.set('cashPriceInfo', cashPricesInfoList);
    };

    generateSummaryModel = (orderItems, slicesModel, isVoucher, isPartialRefund) => {
        const generateInfo = () => {
            const generatePassengerInfo = (passenger, sliceIds) => {
                const addNewPas = (pas) => {
                    currencyObject = getCurrencyToFormat(pas.price.currency);
                    returnInfo.passengersInfo.push({
                        'type': pas.passengerId.slice(0, pas.passengerId.length - 3),
                        'typePlural': 'SOME_' + pas.passengerId.slice(0, pas.passengerId.length - 3),
                        'amount': 1,
                        'farePrice': pas.price.fare,
                        'farePriceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), pas.price.fare, true, false),
                        'taxPrice': pas.price.tax,
                        'taxPriceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), pas.price.tax, true, false),
                        'ticketingFeePrice': pas.price.ticketingFee,
                        'ticketingFeePriceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject),  pas.price.ticketingFee, true, false),
                        'totalPrice': pas.price.total,
                        'totalPriceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), pas.price.total, true, false),
                        'partialSlice': partialSlice
                    });
                };

                let i = 0, isFound = false, currencyObject: any = {}, partialSlice = null;

                if (sliceIds !== null && isPartialRefund) {
                    angular.forEach(slicesInfo, (slice) => {
                        angular.forEach(sliceIds, (paxSlice) => {
                            if (slice.id === paxSlice.id) {
                                partialSlice = slice;
                            }
                        });
                    });
                }

                angular.forEach(passenger, (pas) => {
                    i = 0, isFound = false;
                    returnInfo.totalPassengers++;
                    if (pas.price) {
                        if (returnInfo.passengersInfo.length > 0) {
                            while (!isFound && i < returnInfo.passengersInfo.length) {
                                if (returnInfo.passengersInfo[i].type === pas.passengerId.slice(0, pas.passengerId.length - 3) && returnInfo.passengersInfo[i].farePrice === pas.price.fare) {
                                    isFound = true;
                                    currencyObject = getCurrencyToFormat(pas.price.currency);
                                    returnInfo.passengersInfo[i].amount++;
                                    returnInfo.passengersInfo[i].totalPrice += pas.price.total;
                                    returnInfo.passengersInfo[i].totalPriceFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), returnInfo.passengersInfo[i].totalPrice, true, false);
                                }
                                i++;
                            }
                            if (!isFound) {
                                addNewPas(pas);
                            }
                        } else {
                            addNewPas(pas);
                        }
                    }
                });
            };

            const generateBaggageInfo = (baggage) => {
                const addNewBaggage = (slice, baggage) => {
                    currencyObject = getCurrencyToFormat(baggage.price.currency);
                    slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.BAGGAGE, 'price': baggage.price.fare, 'unitaryPrice': baggage.price.fare / baggage.amount, 'amount': baggage.amount, 'priceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), baggage.price.fare / baggage.amount, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), baggage.price.fare, true, false) });
                    slice.hasBaggage = true;
                };

                let i = 0, isFound = false, currencyObject: any = {};
                angular.forEach(slicesInfo, (slice) => {
                    if (slice.sliceId === baggage.sliceId) {
                        i = 0, isFound = false;
                        if (slice.ancillaries.length > 0) {
                            while (!isFound && i < slice.ancillaries.length) {
                                if (slice.ancillaries[i].type === this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.BAGGAGE && (slice.ancillaries[i].unitaryPrice === baggage.price.fare / baggage.amount || slice.ancillaries[i].price === baggage.price.fare)) {
                                    isFound = true;
                                    currencyObject = getCurrencyToFormat(baggage.price.currency);
                                    slice.ancillaries[i].amount += baggage.amount;
                                    slice.ancillaries[i].price += baggage.price.fare;
                                    slice.ancillaries[i].priceTotalFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), slice.ancillaries[i].price, true, false);
                                }
                                i++;
                            }
                            if (!isFound) {
                                addNewBaggage(slice, baggage);
                            }
                        } else {
                            currencyObject = getCurrencyToFormat(baggage.price.currency);
                            slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.BAGGAGE, 'price': baggage.price.fare, 'unitaryPrice': baggage.price.fare / baggage.amount, 'amount': baggage.amount, 'priceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), baggage.price.fare / baggage.amount, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), baggage.price.fare, true, false) });
                            slice.hasBaggage = true;
                        }
                    }
                });
            };

            const generateSeatsInfo = (seat) => {
                const addNewSeat = (slice, seat, segmentSlice) => {
                    currencyObject = getCurrencyToFormat(seat.price.currency);
                    slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SEAT, 'price': seat.price.fare, 'amount': 1, 'priceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), seat.price.fare, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), seat.price.fare, true, false), 'segmentId': segmentSlice.id });
                    slice.hasSeat = true;
                };

                let i = 0, isFound = false, currencyObject: any = {};
                angular.forEach(slicesInfo, (slice) => {
                    angular.forEach(slice.segments, (segmentSlice) => {
                        if (segmentSlice.id === seat.segmentId) {
                            i = 0, isFound = false;
                            segmentSlice.hasSeat = true;
                            if (slice.ancillaries.length > 0) {
                                while (!isFound && i < slice.ancillaries.length) {
                                    if (slice.ancillaries[i].type === this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SEAT && slice.ancillaries[i].price === seat.price.fare && slice.ancillaries[i].segmentId === seat.segmentId) {
                                        isFound = true;
                                        currencyObject = getCurrencyToFormat(seat.price.currency);
                                        slice.ancillaries[i].amount++;
                                        slice.ancillaries[i].priceTotalFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), slice.ancillaries[i].amount * slice.ancillaries[i].price, true, false);
                                    }
                                    i++;
                                }
                                if (!isFound) {
                                    addNewSeat(slice, seat, segmentSlice);
                                }
                            } else {
                                currencyObject = getCurrencyToFormat(seat.price.currency);
                                slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SEAT, 'price': seat.price.fare, 'amount': 1, 'priceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), seat.price.fare, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), seat.price.fare, true, false), 'segmentId': segmentSlice.id });
                                slice.hasSeat = true;
                            }
                        }
                    });
                });
            };

            const generateFlexInfo = (flex) => {
                var currencyObject: any = {};
                currencyObject = getCurrencyToFormat(flex.price.currency);
                returnInfo.flexibilization.type = flex.type;
                returnInfo.flexibilization.price.fare = flex.price.fare;
                returnInfo.flexibilization.price.priceFormmated = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), flex.price.fare, true, false);
                returnInfo.flexibilization.price.tax = flex.price.tax;
                returnInfo.flexibilization.price.total += flex.price.total;
                returnInfo.flexibilization.price.totalPriceFormmated = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), returnInfo.flexibilization.price.total, true, false);
                returnInfo.flexibilization.subtype = flex.subtype;
                returnInfo.flexibilization.units += 1;


                returnInfo.totalPrice.total += flex.price.total;
                returnInfo.totalPrice.totalPriceFormmated = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), returnInfo.totalPrice.total, true, false);
            };

            const generatePriorityBoarding = (priority) => {
                const addNewPriority = (slice, priority) => {
                    currencyObject = getCurrencyToFormat(priority.price.currency);
                    slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.PRIORITY_BOARDING, 'price': priority.price.fare, 'unitaryPrice': priority.price.fare, 'amount': 1, 'priceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), priority.price.fare, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), priority.price.fare, true, false) });
                    slice.hasPriorityBoarding = true;
                };

                let currencyObject: any = {}, i, isFound;
                angular.forEach(slicesInfo, (slice) => {
                    for (i = 0; i < slice.segments.length; i++) {
                        if (priority.segmentId === slice.segments[i].id) {
                            i = 0, isFound = false;
                            if (slice.ancillaries.length > 0) {
                                while (!isFound && i < slice.ancillaries.length) {
                                    if (slice.ancillaries[i].type === this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.PRIORITY_BOARDING) {
                                        isFound = true;
                                        currencyObject = getCurrencyToFormat(priority.price.currency);
                                        slice.ancillaries[i].amount += 1;
                                        slice.ancillaries[i].price += priority.price.fare;
                                        slice.ancillaries[i].priceTotalFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), slice.ancillaries[i].price, true, false);
                                    }
                                    i++;
                                }
                                if (!isFound) {
                                    addNewPriority(slice, priority);
                                }
                            } else {
                                currencyObject = getCurrencyToFormat(priority.price.currency);
                                slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.PRIORITY_BOARDING, 'price': priority.price.fare, 'unitaryPrice': priority.price.fare, 'amount': 1, 'priceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), priority.price.fare, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), priority.price.fare, true, false) });
                                slice.hasPriorityBoarding = true;
                            }
                        }
                    }
                });
            };

            const generateSpeqsInfo = (speq) => {
                const addNewSpeq = (slice, speq) => {
                    currencyObject = getCurrencyToFormat(speq.price.currency);
                    slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SPEQS, 'price': speq.price.fare, 'unitaryPrice': speq.price.fare / speq.amount, 'amount': speq.amount, 'priceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), speq.price.fare / speq.amount, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), speq.price.fare, true, false) });
                    slice.hasSpeqs = true;
                };

                let i = 0, isFound = false, currencyObject: any = {};
                angular.forEach(slicesInfo, (slice) => {
                    if (slice.sliceId === speq.sliceId) {
                        i = 0, isFound = false;
                        if (slice.ancillaries.length > 0) {
                            while (!isFound && i < slice.ancillaries.length) {
                                if (slice.ancillaries[i].type === this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SPEQS && (slice.ancillaries[i].unitaryPrice === speq.price.fare / speq.amount || slice.ancillaries[i].price === speq.price.fare)) {
                                    isFound = true;
                                    currencyObject = getCurrencyToFormat(speq.price.currency);
                                    slice.ancillaries[i].amount += speq.amount;
                                    slice.ancillaries[i].price += speq.price.fare;
                                    slice.ancillaries[i].priceTotalFormatted = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), slice.ancillaries[i].price, true, false);
                                }
                                i++;
                            }
                            if (!isFound) {
                                addNewSpeq(slice, speq);
                            }
                        } else {
                            currencyObject = getCurrencyToFormat(speq.price.currency);
                            slice.ancillaries.push({ 'type': this.MmBAppConstants.ANCILLARIES_IMPORT_ORDER_TYPE.SPEQS, 'price': speq.price.fare, 'unitaryPrice': speq.price.fare / speq.amount, 'amount': speq.amount, 'priceFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), speq.price.fare / speq.amount, true, false), 'priceTotalFormatted': this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(currencyObject), speq.price.fare, true, false) });
                            slice.hasSpeqs = true;
                        }
                    }
                });
            };
            angular.forEach(orderItems, (item) => {
                switch (item.type.toLowerCase()) {
                        case 'flight':
                            generatePassengerInfo(item.passengerPrices, item.sliceIds);
                            if(this.CommonsSessionStorageService.get('refundFees') && orderItems[0].price.ticketingFee > 0) {
                                returnInfo.ticketingFee = true;
                            } else {
                                returnInfo.ticketingFee = false;
                            }
                            break;

                        case 'baggage':
                            generateBaggageInfo(item);
                            returnInfo.hasBaggage = true;
                            break;

                        case 'seat':
                            generateSeatsInfo(item);
                            returnInfo.hasSeat = true;
                            break;

                        case 'specialequipment':
                            generateSpeqsInfo(item);
                            returnInfo.hasSpeqs = true;
                            break;

                        case 'flexibilityondemand':
                            generateFlexInfo(item);
                            returnInfo.hasFlex = true;
                            break;
                        case 'priorityboarding':
                            generatePriorityBoarding(item);
                            returnInfo.hasPriorityBoarding = true;
                            break;

                }
            });
        };

        const generateSlicesInfo = () => {
            let slices = [], segmentList, sliceOrigin, sliceDestination, originSet = false;
            angular.forEach(slicesModel, (slice) => {
                segmentList = [], originSet = false;
                angular.forEach(slice.segments, (segmentSlice) => {
                    for (let i = 0; i < segmentsInfo.length; i++) {
                        if (segmentSlice.id === segmentsInfo[i].id) {
                            segmentList.push(segmentsInfo[i]);
                        }
                        i === 0 && !originSet ? sliceOrigin = segmentSlice.departure.city : angular.noop;
                        originSet = true;
                        sliceDestination = segmentSlice.arrival.city;
                    }
                });
                slices.push({ 'sliceId': slice.sliceId, 'segments': segmentList, 'ancillaries': [], 'hasBaggage': false, 'hasSeat': false, 'sliceOrigin': sliceOrigin, 'sliceDestination': sliceDestination });
            });
            return slices;
        };

        const getCurrencyToFormat = (currencyCode) => {
            let currencyObject = {}, currencyFound = false, currencyIndex = 0;
            while (!currencyFound && currencyIndex < cashCurrenciesList.length) {
                if (currencyCode === cashCurrenciesList[currencyIndex].code) {
                    currencyFound = true;
                    currencyObject = cashCurrenciesList[currencyIndex];
                } else
                    currencyIndex++;
            }

            return currencyObject;
        };

        let segmentsInfo = [], slicesInfo, cashCurrenciesList,
            returnInfo: any = {
                'passengersInfo': [],
                'slicesInfo': null,
                'hasBaggage': false,
                'hasSeat': false,
                'hasFlex': false,
                'hasSpeqs': false,
                'hasPriorityBoarding': false,
                'priorityBoarding': {
                    'type': '',
                    'price': {
                        'fare': 0,
                        'tax': 0,
                        'total': 0,
                        'totalPriceFormmated': ''
                    },
                    'units': 0
                },
                'flexibilization': {
                    'type': '',
                    'price': {
                        'fare': 0,
                        'tax': 0,
                        'total': 0,
                        'totalPriceFormmated': ''
                    },
                    'units': 0,
                    'subtype': ''
                },
                'totalPrice': {
                    'totalPriceFormmated': '',
                    'total': 0
                },
                'isPartialRefund': false,
                'totalPassengers': 0
            };

        isVoucher ? cashCurrenciesList = this.CommonsSessionStorageService.get('voucherCurrenciesList') : cashCurrenciesList = this.CommonsSessionStorageService.get('cashCurrenciesList');

        angular.forEach(slicesModel, (slice) => {
            angular.forEach(slice.segments, (segment) => {
                segmentsInfo.push({
                    'id': segment.id,
                    'origin': segment.departureCity,
                    'destination': segment.arrivalCity
                });
            });
        });
        slicesInfo = generateSlicesInfo();
        generateInfo();

        returnInfo.slicesInfo = slicesInfo;
        isPartialRefund ? returnInfo.isPartialRefund = true : angular.noop;
        return returnInfo;
    };

    removeAllParams = () => {
        const url = window.location.href.split('?')[0];
        return url.substring(0, url.length - 1);
    };

    formatDisruptionAndFlexibilizationDates = (dates, type) => {
        const formatBlackoutDates = (datesList) => {
            let blackoutDateIndex, fromContraction = this.$filter('translate')('MMB_FLIGHT_CHANGE_CONTRACTION_FROM_1'),
                toContraction = this.$filter('translate')('MMB_FLIGHT_CHANGE_CONTRACTION_TO_1'),
                fromContractionLast = this.$filter('translate')('MMB_FLIGHT_CHANGE_CONTRACTION_TO_3'),
                zhAndjpLastTag = this.$filter('translate')('MMB_FLIGHT_CHANGE_BLACKOU_ZH_AND_JP_TAG'), formattedDateFrom, formattedDateTo;

            if (datesList.length >= 1) {
                for (blackoutDateIndex = 0; blackoutDateIndex < datesList.length; blackoutDateIndex++) {
                    if (datesList[blackoutDateIndex].dateFrom && datesList[blackoutDateIndex].dateTo) {
                        formattedDateFrom = this.$filter('DateFormatFilter')(datesList[blackoutDateIndex].dateFrom);
                        formattedDateTo = this.$filter('DateFormatFilter')(datesList[blackoutDateIndex].dateTo);
                        if (blackoutDateIndex === datesList.length - 1 && datesList.length > 1) {
                            formattedString += fromContractionLast + ' ' + formattedDateFrom.formatedDate + ' ' + toContraction + ' ' + formattedDateTo.formatedDate + zhAndjpLastTag;
                        } else {
                            formattedString += fromContraction + ' ' + formattedDateFrom.formatedDate + ' ' + toContraction + ' ' + formattedDateTo.formatedDate + ', ';
                        }
                    }
                }
            }
        };

        const formatAllowedPeriodDates = (date) => {
            let formattedDateTo;
            if (date && date.length >= 1) {
                if (date[0].dateTo) {
                    formattedDateTo = this.$filter('DateFormatFilter')(date[0].dateTo);
                    formattedString = formattedDateTo.formatedDate;
                }
            }
        };

        const formatFlexibilizationDates = (dateList) => {
            let formattedDateSince, formattedDateLimit, betweenContraction = this.$filter('translate')('MMB_FLIGHT_CHANGE_CONTRACTION_TO_2');

            if (dateList && dateList.since && dateList.limit) {
                formattedDateSince = this.$filter('DateFormatFilter')(dateList.since);
                formattedDateLimit = this.$filter('DateFormatFilter')(dateList.limit);
                formattedString = formattedDateSince.formatedDate + ' ' + betweenContraction + ' ' + formattedDateLimit.formatedDate + '';
            }

        };

        let formattedString = '';
        switch (type) {
                case 'BLACKOUT':
                    formatBlackoutDates(dates);
                    break;
                case 'ALLOWED_PERIODS':
                    formatAllowedPeriodDates(dates);
                    break;
                case 'FLEXIBILIZATION_RANGE':
                    formatFlexibilizationDates(dates);
                    break;
                default:
                    break;
        }

        return formattedString;
    };

    removeDuplicates = (citiesList) => {
        let initialListIndex, uniqueListIndex, filteredList = [], uniqueObject = {}, objCode;
        for (initialListIndex = 0; initialListIndex < citiesList.length; initialListIndex++) {
            objCode = null;
            objCode = citiesList[initialListIndex]['code'];
            uniqueObject[objCode] = citiesList[initialListIndex];
        }
        for (uniqueListIndex in uniqueObject) {
            filteredList.push(uniqueObject[uniqueListIndex]);
        }
        return filteredList;
    };


    /**
     *
     * @param {*} orderItems  All order items, the function looks for 'baggage' orderItems.
     */
    checkSisterCitiesSuitableByEMDAndPNR = (orderItems, bookingReferences) => {
        let itemIndex, suitableForSisterCities = true, providerIndex, validPNR = false;

        for (providerIndex = 0; providerIndex < bookingReferences.length; providerIndex++) {
            if (bookingReferences[providerIndex].provider === '1A') {
                validPNR = true;
            }
        }

        if (validPNR) {
            for (itemIndex = 0; itemIndex < orderItems.length; itemIndex++) {
                if (orderItems[itemIndex].type === 'baggage' && orderItems[itemIndex].price && orderItems[itemIndex].price.total > 0) {
                    suitableForSisterCities = false;
                    break;
                }
            }
        } else {
            suitableForSisterCities = false;
        }

        return suitableForSisterCities;
    };

    newTransformSisterCitiesModel = (rawModel, isFlex, slicesInfo, flightsInfo) => {

        const getSisterCities = (cityCode) => {
            const sisterCities = rawModel.cities.find(e => e.code === cityCode);
            if(sisterCities) {
                return sisterCities.sisterCities;
            } else {
                return [];
            }
        };

        let newTransformedSisterCitiesModel: any = {}, sisterCitiesOrigin, sisterCitiesDestination;

        newTransformedSisterCitiesModel.disruptedSlices = [];
        newTransformedSisterCitiesModel.switchSisterCities = false;
        newTransformedSisterCitiesModel.sisterCitiesOptionChecked = false;

        slicesInfo.forEach(slice => {

            //save all sliceId's, independent of disruption or not
            newTransformedSisterCitiesModel.disruptedSlices.push(slice.sliceId);

            //Disrupted slice (including UN/TK or TK segments)
            if (slice.originalDisruptionSliceInformation) {

                sisterCitiesOrigin = getSisterCities(slice.originalDisruptionSliceInformation.departure.city.code);
                sisterCitiesDestination = getSisterCities(slice.originalDisruptionSliceInformation.arrival.city.code);

                newTransformedSisterCitiesModel[slice.sliceId] = {
                    'origin': {
                        'originOrderCities': {
                            'code': slice.originalDisruptionSliceInformation.departure.city.code,
                            'description': slice.originalDisruptionSliceInformation.departure.city.description
                        },
                        'originSisterCities': sisterCitiesOrigin ? sisterCitiesOrigin : []

                    },
                    'destination': {
                        'destinationOrderCities': {

                            'code': slice.originalDisruptionSliceInformation.arrival.city.code,
                            'description': slice.originalDisruptionSliceInformation.arrival.city.description
                        },
                        'destinationSisterCities': sisterCitiesDestination ? sisterCitiesDestination : []
                    }
                };

            //Not-disrupted slice or slices with UN segments (cancellated segments)
            } else {

                const numSegments = slice.segments.length;
                sisterCitiesOrigin = getSisterCities(slice.segments[0].departure.city.code);
                sisterCitiesDestination = getSisterCities(slice.segments[numSegments - 1].arrival.city.code);

                newTransformedSisterCitiesModel[slice.sliceId] = {
                    'origin': {
                        'originOrderCities': {
                            'code': slice.segments[0].departure.city.code,
                            'description': slice.segments[0].departure.city.description
                        },
                        'originSisterCities': sisterCitiesOrigin ? sisterCitiesOrigin : []
                    },
                    destination: {
                        'destinationOrderCities': {
                            'code': slice.segments[numSegments - 1].arrival.city.code,
                            'description': slice.segments[numSegments - 1].arrival.city.description
                        },
                        'destinationSisterCities': sisterCitiesDestination ? sisterCitiesDestination : []
                    }
                };
            }

            newTransformedSisterCitiesModel[slice.sliceId]['originHasSisterCities'] = sisterCitiesOrigin.length > 0 ? true : false;
            newTransformedSisterCitiesModel[slice.sliceId]['originSisterCitiesNum'] = sisterCitiesOrigin.length > 0 ? '+' + sisterCitiesOrigin.length : null;
            newTransformedSisterCitiesModel[slice.sliceId]['destinationHasSisterCities'] = sisterCitiesDestination.length > 0 ? true : false;
            newTransformedSisterCitiesModel[slice.sliceId]['destinationSisterCitiesNum'] = sisterCitiesDestination.length > 0 ? '+' + sisterCitiesDestination.length : null;
            newTransformedSisterCitiesModel[slice.sliceId]['index'] = sisterCitiesDestination.length > 0 ? '+' + sisterCitiesDestination.length : null;
        });
        if (!flightsInfo) flightsInfo = [];
        Object.keys(flightsInfo).map((flight)=>{
            newTransformedSisterCitiesModel[flight].index =  flightsInfo[flight].index;
        });

        // Set the referenceSliceId depending on flex or disruption or cancellation
        // When there is flexibility, all slices are flex => We take first slice as reference
        if(isFlex){
            newTransformedSisterCitiesModel.referenceSliceId = slicesInfo[0].sliceId;

        //Evaluate if there are 2 slices, and only one is disrupted
        } else if(flightsInfo[newTransformedSisterCitiesModel.disruptedSlices[0]]?.disrupted && !flightsInfo[newTransformedSisterCitiesModel.disruptedSlices[1]]?.disrupted){
            newTransformedSisterCitiesModel.referenceSliceId = newTransformedSisterCitiesModel.disruptedSlices[0];
            newTransformedSisterCitiesModel.switchSisterCities = true;
        } else if(flightsInfo[newTransformedSisterCitiesModel.disruptedSlices[1]]?.disrupted && !flightsInfo[newTransformedSisterCitiesModel.disruptedSlices[0]]?.disrupted){
            newTransformedSisterCitiesModel.referenceSliceId = newTransformedSisterCitiesModel.disruptedSlices[1];
            newTransformedSisterCitiesModel.switchSisterCities = true;

        //In any other case, take the first slice as a reference
        } else{
            newTransformedSisterCitiesModel.referenceSliceId = slicesInfo[0].sliceId;
        }

        return newTransformedSisterCitiesModel;
    };


    updateSisterCitiesModel = (sisterCitiesModel) => {
        const calculateCitiesSelected = (cityList) => {
            var cont = 0;
            angular.forEach(cityList, (city) => {
                if (city.isSelected) {
                    cont++;
                }
            });

            if(cont === 0) {
                return null;
            }
            return '+' + cont;
        };

        sisterCitiesModel[sisterCitiesModel.referenceSliceId].originSisterCitiesNum = calculateCitiesSelected(sisterCitiesModel[sisterCitiesModel.referenceSliceId].origin.originSisterCities);
        sisterCitiesModel[sisterCitiesModel.referenceSliceId].destinationSisterCitiesNum = calculateCitiesSelected(sisterCitiesModel[sisterCitiesModel.referenceSliceId].destination.destinationSisterCities);
    };

    /**
    * This functions return request to get all data about availability flexibles flights
    * @param {Object} flights All information about flights
    * @param {String} flowId flowId
    * @returns {Object} 'availabilityFlexRequest' with all information neccesary to call service.
    *  */
    generateRequestFlexibilization = (flights, flowId, sisterCityModel) => {
        const transformerDateSelected = (date) => {
            const parseDate = {
                'day': date.getDate(),
                'month': date.getMonth() + 1,
                'year': date.getFullYear(),
                'weekDay': date.getDay()
            };
            return parseDate;
        };

        const buildSliceRequest = (sliceItem, sliceId, sisterCityModel, counter) => {
            let result: any = {};
            result.sliceId = sliceId;
            if(this.CommonsSessionStorageService.get('isUnifiedFlow') && this.CommonsSessionStorageService.get('isSearchFromButton')) {
                sliceItem.parseNewDateSelected = transformerDateSelected(sliceItem.newDateSelected);
            }
            result.date = this.getDateFormatted(sliceItem.parseNewDateSelected.day, sliceItem.parseNewDateSelected.month, sliceItem.parseNewDateSelected.year);
            if (sisterCityModel) {
                result.origins = [];
                result.destinations = [];
                angular.forEach(sisterCityModel[sisterCityModel.referenceSliceId].origin.originSisterCities, (city) => {
                    if (city.isSelected) {
                        if (counter === 1) {
                            result.destinations.push(city.code);
                        } else {
                            result.origins.push(city.code);
                        }
                    }
                });
                angular.forEach(sisterCityModel[sisterCityModel.referenceSliceId].destination.destinationSisterCities, (city) => {
                    if (city.isSelected) {
                        if (counter >= 1) {
                            result.origins.push(city.code);
                        } else {
                            result.destinations.push(city.code);
                        }
                    }
                });
            }

            // if(result.destinations?.length > 0 && result.origins?.length > 0){
            //     let array = result.destinations.concat(result.origins);
            //     let hasDuplicates = array.some(x => array.indexOf(x) !== array.lastIndexOf(x));
            //     if(hasDuplicates){
            //         let error;
            //         error = {title:'', message:''};
            //         error.title = 'Lo sentimos mucho';
            //         error.message = 'Vuelo con mismo origen y destino';
            //         this.MmBModalService.showGenericError(error).result.then( () => {
            //         }, angular.noop);
            //     }
            //     else{
            //         return result;
            //     }
            // }

            return result;
        };

        let availabilityFlexRequest: any = {}, slicesInfo = [], sliceId, counter = 0;
        availabilityFlexRequest.flowId = flowId ? flowId : this.CommonsSessionStorageService.get('flowId') ? this.CommonsSessionStorageService.get('flowId') : null;

        if (sisterCityModel) {
            angular.forEach(sisterCityModel.disruptedSlices, (sliceId) => {
                if (sisterCityModel.referenceSliceId === sliceId) {
                    //counter = 0 means 'origin'
                    counter = 0;
                } else {
                    //counter = 1 means 'destiny'
                    counter = 1;
                }

                if (flights.hasOwnProperty(sliceId)) {
                    if (flights[sliceId].disrupted || flights[sliceId].optionalEnabled || flights[sliceId].checked) {
                        slicesInfo.push(buildSliceRequest(flights[sliceId], sliceId, sisterCityModel, counter));
                    }
                }
            });
        } else {
            for (sliceId in flights) {
                if (flights.hasOwnProperty(sliceId)) {
                    if (flights[sliceId].disrupted || flights[sliceId].optionalEnabled || flights[sliceId].checked) {
                        slicesInfo.push(buildSliceRequest(flights[sliceId], sliceId, sisterCityModel, counter));
                    }
                }
                counter++;
            }
        }
        availabilityFlexRequest.slices = slicesInfo;
        return availabilityFlexRequest;
    };

    /**
     * Obtains the flag value from a container list of flags
     * @param {Object} containerObj The flags container
     * @param {String} attribName Name of the atribute which holds the flag name
     * @param {String} attribValue Name of the property which holds the flag value
     * @param {String} flagName Value of the flag to evaluate
     */
    getFlagValue = (containerObj, attribName, attribValue, flagName) => {
        let flagIndex = 0;
        let found = false;
        let value = false;
        if (containerObj) {
            while (flagIndex < containerObj.length && !found) {
                if (containerObj[flagIndex][attribName] === flagName) {
                    found = true;
                    value = containerObj[flagIndex][attribValue];
                }
                flagIndex++;
            }
        }
        return value;
    };

    generateFlexAndDisruptedFlightsDatalayerInfo = (isDisrupted, model) => {
        const createDisruptedFlightInfo = () => {
            if (model.selectorFlights && model.selectorFlights.flights) {
                getFlightTypeAndOriginalDates(model.selectorFlights);
                if (model.tickets) {
                    getOriginalIssueDateAndAnticipationDays(model.tickets);
                }
            }

            if (model.orderItems) {
                generateOrderItemsInfo(model.orderItems);
            }

            if (model.passengersInfo) {
                generatePassengersInfo(model.passengersInfo);
            }
        };

        const createFlexFlightInfo = () => {
            if (model.yourFlightsModel && model.yourFlightsModel.flights) {
                getFlightTypeAndOriginalDates(model.yourFlightsModel);
            }

            if (model.managementModel) {
                if (model.managementModel.orderItems) {
                    generateOrderItemsInfo(model.managementModel.orderItems);
                }
                if (model.managementModel.aviosRedeemed) {
                    aviosDiscount = model.managementModel.aviosRedeemedAmount;
                }
            }

            if (model.bookingGeneralInfo) {
                if (model.bookingGeneralInfo.tickets) {
                    getOriginalIssueDateAndAnticipationDays(model.bookingGeneralInfo.tickets);
                }
            }

            if (model.passengersModel) {
                generatePassengersInfo(model.passengersModel.passengers);
            }
        };

        /**
         * Generates from a flight model (same for flexible and disrupted flights) the information related to flight type and it's dates.
         */
        const getFlightTypeAndOriginalDates = (flightsModel) => {
            for (sliceId in flightsModel.flights) {
                flightsCount++;
                slicesIds.push(sliceId);
            }

            firstFlight = slicesIds[0];
            originDestination = flightsModel.flights[firstFlight].departureCity.code + '-' + flightsModel.flights[firstFlight].arrivalCity.code;


            countries = flightsModel.flights[firstFlight].departureCountry + '-' + flightsModel.flights[firstFlight].arrivalCountry;


            if (flightsCount >= 2) {
                secondFlight = slicesIds[1];
                if (flightsModel.flights[firstFlight].arrivalCity.code !== flightsModel.flights[secondFlight].departureCity.code) {
                    flightType = MMBDatalayerConstants.DATALAYER_VALUES.MULTIPLE_TRIP;
                } else {
                    flightType = MMBDatalayerConstants.DATALAYER_VALUES.RETURN_TRIP;
                }
                if (flightsModel.flights[firstFlight].departureCountry !== flightsModel.flights[secondFlight].departureCountry && flightsModel.flights[firstFlight].departureCountry !== flightsModel.flights[firstFlight].arrivalCountry) {
                    countries = countries + '-' + flightsModel.flights[secondFlight].departureCountry;
                }
                getOriginalFlightDates(MMBDatalayerConstants.DATALAYER_VALUES.RETURN_TRIP, flightsModel);
            } else {
                flightType = MMBDatalayerConstants.DATALAYER_VALUES.ONE_WAY_TRIP;
                getOriginalFlightDates(MMBDatalayerConstants.DATALAYER_VALUES.ONE_WAY_TRIP, flightsModel);
            }
        };

        /**
         * Generates ancillaries (orderitems) information.
         */
        const generateOrderItemsInfo = (orderItemsList) => {
            const getPrices = (itemList) => {
                var index, totalPrice = 0;
                for (index = 0; index < itemList.length; index++) {
                    totalPrice += itemList[index].price ? itemList[index].price.total : 0;
                }
                return totalPrice;
            };

            for (orderItemId in orderItemsList) {
                switch (orderItemId) {
                        case 'seat':
                            datalayerOrderItemsInfo.hasSeats = true;
                            datalayerOrderItemsInfo.seatsPrice = getPrices(orderItemsList[orderItemId]);
                            break;
                        case 'baggage':
                            datalayerOrderItemsInfo.hasBaggages = true;
                            datalayerOrderItemsInfo.baggagesPrice = getPrices(orderItemsList[orderItemId]);
                            break;
                        case 'specialNeed':
                            datalayerOrderItemsInfo.hasSpecialNeeds = true;
                            break;
                        case 'insurance':
                            datalayerOrderItemsInfo.hasInsurance = true;
                            datalayerOrderItemsInfo.insurancePrice = getPrices(orderItemsList[orderItemId]);
                            break;
                        case 'specialMeal':
                            datalayerOrderItemsInfo.hasSpecialNeeds = true;
                            break;
                }
            }
        };

        /**
         * Sets original flight dates and days in destination.
         */
        const getOriginalFlightDates = (tripType, flightsModel) => {
            switch (tripType) {
                    case MMBDatalayerConstants.DATALAYER_VALUES.ONE_WAY_TRIP:
                        originalDepartureDate = flightsModel.flights[firstFlight].departureDateParsed.formatedDate;
                        break;
                    case MMBDatalayerConstants.DATALAYER_VALUES.RETURN_TRIP:
                        originalDepartureDate = flightsModel.flights[firstFlight].departureDateParsed.formatedDate;
                        originalReturnDate = flightsModel.flights[secondFlight].departureDateParsed.formatedDate;
                        break;
            }
            if (!originalReturnDate) {
                originalFlightDate = originalDepartureDate;
            } else {
                originalFlightDate = originalDepartureDate + '-' + originalReturnDate;
                daysInDestination = this.getDaysDifference(originalReturnDate, originalDepartureDate);
            }
        };

        /**
         * Create difference days between ticket issue and departure of 1st flight.
         */
        const getOriginalIssueDateAndAnticipationDays = (ticketsList) => {
            angular.forEach(ticketsList, (ticket) => {
                if (ticket.issueDateTime) {
                    originalIssueDate = ticket.issueDateTime;
                    originalIssueDateFormatted = this.$filter('DateFormatFilter')(originalIssueDate).formatedDate;
                }
            });
            anticipationDays = this.getDaysDifference(originalDepartureDate, originalIssueDateFormatted);
        };

        /**
         * Set PNR's type (flexible, disrupted or non flexible, depending on order capabilities, status and flag's vlaue).
         */
        const generatePnrType = () => {
            if (model.flags && model.flags.showFlexibilizationChangeSection && model.orderCapabilities) {
                pnrType = MMBDatalayerConstants.DATALAYER_VALUES.FLEXIBLE;
            } else {
                if (isDisrupted) {
                    pnrType = MMBDatalayerConstants.DATALAYER_VALUES.DISRUPTED;
                } else {
                    pnrType = MMBDatalayerConstants.DATALAYER_VALUES.NON_FLEXIBLE;
                }
            }
        };

        const generatFlightStatus = () => {
            let status = null, sliceIndex = 0, firstFlightSelected = false, secondFlightSelected = false, hasUN = false, hasUNTK = false, hasTK = false, cabinClsTitle, sliceCabinClasses;
            if (isDisrupted) {
                angular.forEach(model.rawSlicesInfo, (slice) => {
                    sliceIndex++, sliceCabinClasses = '';
                    slice.segments.forEach((segment, index, list) => {
                        switch (segment.status.code) {
                                case 'UN':
                                    hasUN = true;
                                    break;
                                case 'UNTK':
                                    hasUNTK = true;
                                    break;
                                case 'TK':
                                    hasTK = true;
                                    break;

                        }

                        if (segment.id) {
                            if (sliceIndex === model.rawSlicesInfo.length) {
                                identifierList += segment.id;
                            } else {
                                identifierList += segment.id + '-';
                            }
                        }
                        if (segment.flight.operationalCarrier) {
                            if (sliceIndex === model.rawSlicesInfo.length) {
                                carrier += segment.flight.operationalCarrier.code;
                            } else {
                                carrier += segment.flight.operationalCarrier.code + '-';
                            }
                        }
                        if (index === list.length - 1) {
                            sliceCabinClasses += segment.cabin.bookingClass ? segment.cabin.bookingClass : 'ND';
                        } else {
                            sliceCabinClasses += (segment.cabin.bookingClass ? segment.cabin.bookingClass : 'ND') + ',';
                        }
                        if (sliceIndex === 1 && !firstFlightSelected) {
                            stopsPerSlice = 'IDA:' + slice.stopsNumber;
                            firstFlightSelected = true;
                        } else {
                            if (!secondFlightSelected) {
                                stopsPerSlice += '-VUELTA:' + slice.stopsNumber;
                                secondFlightSelected = true;
                            }
                        }
                    });
                    if (sliceIndex === 1) {
                        cabinClsTitle = 'IDA:';
                        cabinClasses = cabinClsTitle + sliceCabinClasses + ',';
                    } else {
                        cabinClsTitle = 'VUELTA:';
                        cabinClasses += cabinClsTitle + sliceCabinClasses;
                    }
                });
                if (hasUN) {
                    status = 'UN';
                } else {
                    if (hasUNTK) {
                        status = 'UNTK';
                    } else {
                        if (hasTK) {
                            status = 'TK';
                        } else {
                            status = 'HK';
                        }
                    }
                }
            } else {
                angular.forEach(model.rawSlicesInfo, (slice) => {
                    sliceIndex++;
                    angular.forEach(slice.segments, (segment) => {
                        if (sliceIndex === 1 && !firstFlightSelected) {
                            cabinClasses = 'IDA:';
                            firstFlightSelected = true;
                        } else {
                            if (sliceIndex > 1 && !secondFlightSelected) {
                                cabinClasses += 'VUELTA:';
                                secondFlightSelected = true;
                            }
                        }
                        if (segment.id) {
                            if (sliceIndex === model.rawSlicesInfo.length) {
                                identifierList += segment.id;
                            } else {
                                identifierList += segment.id + '-';
                            }
                        }
                        if (segment.flight.operationalCarrier) {
                            if (sliceIndex === model.rawSlicesInfo.length) {
                                carrier += segment.flight.operationalCarrier.code;
                            } else {
                                carrier += segment.flight.operationalCarrier.code + '-';
                            }
                        }
                        cabinClasses += (segment.cabin.bookingClass ? segment.cabin.bookingClass : 'ND') + ',';
                        status = 'HK';
                    });
                });
            }
            return status;
        };

        /**
         * Generates passengers information (total amount and each type's amount);
         */
        const generatePassengersInfo = (passengersModel) => {
            passengersInfo.totalAmount = passengersModel.length;
            angular.forEach(passengersModel, (passenger) => {
                switch (passenger.passengerType) {
                        case 'ADULT':
                            passengersInfo.adults++;
                            break;
                        case 'SENIOR':
                            passengersInfo.seniors++;
                            break;
                        case 'YOUTH':
                            passengersInfo.young++;
                            break;
                        case 'YOUNG':
                            passengersInfo.teenagers++;
                            break;
                        case 'YOUNG_ADULT':
                            passengersInfo.youngAdults++;
                            break;
                        case 'CHILD':
                            passengersInfo.kids++;
                            break;
                        case 'INFANT':
                            passengersInfo.babies++;
                            break;
                }
            });
        };

        const generateDatalayerPricesInfo = () => {
            pricesInfo.totalTax = 0;
            pricesInfo.noTax = 0;

            if(model.pricesInfo?.total && Number(model.pricesInfo.total)) {
                pricesInfo.totalTax = model.pricesInfo.total;
            } else if(model.pricesInfo?.totalPaid && Number(model.pricesInfo.totalPaid)){
                pricesInfo.totalTax = model.pricesInfo.totalPaid;
            }

            if(model.pricesInfo?.fare && Number(model.pricesInfo?.fare)) {
                pricesInfo.noTax = model.pricesInfo.total;
            }
        };


        var sliceId, flightsCount = 0, slicesIds = [], firstFlight, secondFlight, orderItemId,
            pnrType, flightStatus = null, flightType = null, originalFlightDate = null, originalIssueDate = null,
            daysInDestination = null, aviosDiscount = null, countries = null, originalIssueDateFormatted = null, cabinClasses = null, stopsPerSlice = null, carrier = '',
            anticipationDays = null, originalDepartureDate = null, originalReturnDate = null, voucherDiscount = null, originDestination = null, identifierList = '',
            datalayerOrderItemsInfo = {
                'hasSeats': false,
                'seatsPrice': 0,
                'hasBaggages': false,
                'baggagesPrice': 0,
                'hasSpecialNeeds': false,
                'hasInsurance': false,
                'insurancePrice': 0,
                'hasSpecialMeal': false
            }, passengersInfo = {
                'totalAmount': 0,
                'adults': 0,
                'youngAdults': 0,
                'teenagers': 0,
                'seniors': 0,
                'babies': 0,
                'kids': 0,
                'young': 0
            }, pricesInfo = {
                'totalTax': 0,
                'noTax': 0
            };
        generatePnrType();
        flightStatus = generatFlightStatus();

        if (isDisrupted) {
            createDisruptedFlightInfo();
            generateDatalayerPricesInfo();
        } else {
            createFlexFlightInfo();
            generateDatalayerPricesInfo();
        }

        if (model.voucherPriceInfo && model.voucherPriceInfo.percentagePrice) {
            voucherDiscount = model.voucherPriceInfo.percentagePrice;
        }

        this.MmBDatalayerUtilsService.updateDigitalDataForFlexFlights(this.generateObjectDigitalDataForFlexFlights(model, flightStatus, anticipationDays, originalFlightDate, daysInDestination,  pnrType, originalIssueDateFormatted, originalDepartureDate, originalReturnDate, voucherDiscount, aviosDiscount, passengersInfo, pricesInfo, flightType, isDisrupted));
        this.MmBDatalayerUtilsService.updateSlicesDatalayerForFlexFlights(this.CommonsSessionStorageService.get('bookingInfo'), this.CommonsSessionStorageService.get('breakdownInfo'));
    };

    createOnHoldConfirmationDatalayer = (model:OnHoldModel) => {
        const bookingInfo = this.CommonsSessionStorageService.get('bookingInfo');
        const fstatus = bookingInfo?.order?.status;
        const slices = bookingInfo?.order?.slices;
        const ftype = model?.generalInfo?.tripType==2 ? MMBDatalayerConstants.DATALAYER_VALUES.RETURN_TRIP: MMBDatalayerConstants.DATALAYER_VALUES.ONE_WAY_TRIP;
        const sliceDates: Array<string> = bookingInfo?.order?.slices?.map(el => el?.departureDateTime ?? '') ?? []
        const airportSeg = `${model?.generalInfo?.origin?.code}-${model?.generalInfo?.destination?.code}`;
        const flightHaul = bookingInfo?.order?.flightRatio
        const entryQuadrigam = this.$rootScope.isLogged? this.MmBAppConstants.QUADRIGAM.LOGGED_SEARCH:  this.MmBAppConstants.QUADRIGAM.SEARCH;
        const passengersInfo = {
            'totalAmount': 0,
            'adults': 0,
            'youngAdults': 0,
            'teenagers': 0,
            'seniors': 0,
            'babies': 0,
            'kids': 0,
            'young': 0
        };
        const generatePassengersInfo = (passengersModel= []) => {
            passengersInfo.totalAmount = passengersModel.length;
            angular.forEach(passengersModel, (passenger) => {
                switch (passenger.passengerType) {
                        case 'ADULT':
                            passengersInfo.adults++;
                            break;
                        case 'SENIOR':
                            passengersInfo.seniors++;
                            break;
                        case 'YOUTH':
                            passengersInfo.young++;
                            break;
                        case 'YOUNG':
                            passengersInfo.teenagers++;
                            break;
                        case 'YOUNG_ADULT':
                            passengersInfo.youngAdults++;
                            break;
                        case 'CHILD':
                            passengersInfo.kids++;
                            break;
                        case 'INFANT':
                            passengersInfo.babies++;
                            break;
                }
            });
        };
        generatePassengersInfo( model?.passengers );
        const specialDiscounts = { specialDiscounts: bookingInfo?.order?.specialDiscounts || [] };
        const generateObject = this.generateObjectDigitalDataForOnHold( fstatus, ftype, sliceDates, airportSeg, passengersInfo, flightHaul, slices, model );
        Object.assign( generateObject, specialDiscounts );
        this.MmBDatalayerUtilsService.updateDigitalDataForFlexFlights( generateObject );
        this.MmBDatalayerUtilsService.addDigitalDataInfo({ [MMBDatalayerConstants.DatalayerBKIConstants.PROCESS_START]: `${this.$rootScope.appLang}/${this.$rootScope.appMarket}/${entryQuadrigam}`});
    };

    /**
    * Return date with slash separator
    * @param {Object} date Object with date values
    * @return {String} Date formated with slash separator
    */
    getMiddleDashDate = (date) => {
        let dateSlice = '';
        if (date) {
            dateSlice = date.year + '-' + (date.monthNumber < 10 ? '0' + date.monthNumber : date.monthNumber) + '-' + (date.monthDay < 10 ? '0' + date.monthDay : date.monthDay);
        }
        return dateSlice;
    };

    /**
     * This function redirection to Home when user do click icon IBERIA in new-header.
     *  */
    goToHome = () => {
        // Clear all own session storage app entries
        this.CommonsSessionStorageService.clearAll();
        this.$window.location.href = this.$window.location.origin;
    };

    getDifferenceBetweenTwoArrayObjects = (array1, array2, value) => {
        return array1.filter((object) => {
            return !array2.some((object2) => {
                return object[value] === object2[value];
            });
        });
    };

    groupByKey = (array, key) => {
        return array.reduce((reduceValue, x) => {
            (reduceValue[x[key]] = reduceValue[x[key]] || []).push(x);
            return reduceValue;
        }, {});
    };

    getUniqueElementByProperty = (array, property) => {
        let keys = array.map((value) => { return value[property]; });
        return array.filter((value, index) => { return keys.indexOf(value[property]) === index; });
    };

    generateRedirectionForm = (formData) => {
        let i, form = '<form action="' + this.$sce.trustAsResourceUrl(formData.url) + '" method="post">';
        for (i = 0; i < formData.params.length; i++) {
            form += '<input type="hidden" name="' + formData.params[i].paramName + '" value="' + formData.params[i].paramValue + '" />';
        }
        form += '<input type="submit" id="submit_hidden_form" class="u-hide" /></form>';
        return form;
    };

    generateRedirectionFormCancel = (formData) => {
        let i, form = '<form action="' + this.$sce.trustAsResourceUrl(formData.url) + '" method="post">';
        for (i = 0; i < formData.params.length; i++) {
            form += '<input type="hidden" name="' + formData.params[i].name + '" value="' + formData.params[i].value + '" />';
        }
        form += '<input type="submit" id="submit_hidden_form" class="u-hide" /></form>';
        return form;
    };

    orderItemContained = (orderItems, typeList) => {
        var i = 0, found = false, transformedData;
        transformedData = this.getElementsByProperty(orderItems, 'type', true);
        while(i<typeList.length && !found){
            if(transformedData[typeList[i]]){
                found = true;
            }
            i++;
        }
        return found;
    };

    /**
    * Return preconditions to call sister cities endpoint returning if is specific or generic or none
    * @param {Object} bookingInfo Object with date values
    * @returns {DisruptionTypeModel} 'preconditions sister cities enum' with information to make sister cities request.
    */
    getDisruptionType (bookingInfo) : DisruptionTypeModel {
        let disruptionParams: DisruptionTypeModel = DEFAULT_DISRUPTION_TYPE_MODEL;
        if(bookingInfo?.flexibilizationCapabilitiesInformation && !bookingInfo?.genericDisruptionCapabilitiesInformation
            ) {
                disruptionParams.disruptionType = 'SPECIFIC';
                disruptionParams.disruptionId = bookingInfo?.flexibilizationCapabilitiesInformation.id;
        }
        else if(!bookingInfo?.flexibilizationCapabilitiesInformation && bookingInfo?.genericDisruptionCapabilitiesInformation
            ) {
                disruptionParams.disruptionType = 'GENERIC';
                disruptionParams.disruptionId = bookingInfo?.genericDisruptionCapabilitiesInformation.id;
        }
        else {
            disruptionParams.disruptionType = 'NONE';
            disruptionParams.disruptionId = null;
        }
        return disruptionParams;
    }

    private generateObjectDigitalDataForFlexFlights = (model, flightStatus, anticipationDays, originalFlightDate, daysInDestination,  pnrType, originalIssueDateFormatted, originalDepartureDate, originalReturnDate, voucherDiscount, aviosDiscount, passengersInfo, pricesInfo, flightType, isDisrupted) => {
        const objectDigitalDataForFlexFlights:datalayerServiceTypes.TypeDigitalDataForFlexFlights = {} as datalayerServiceTypes.TypeDigitalDataForFlexFlights;
        const customerDataOB = JSON.parse(sessionStorage.getItem('customerDataOB'));
        objectDigitalDataForFlexFlights.aviosEarned = this.getAvios();
        objectDigitalDataForFlexFlights.changeAcceptance = this.getChangeAcceptance(model, isDisrupted);
        objectDigitalDataForFlexFlights.changeType = this.getChangeType();
        objectDigitalDataForFlexFlights.flightStatus = flightStatus;
        objectDigitalDataForFlexFlights.originalAdvancePurchase = anticipationDays;
        objectDigitalDataForFlexFlights.originalDate = originalFlightDate;
        objectDigitalDataForFlexFlights.originalLengthStay = daysInDestination;
        objectDigitalDataForFlexFlights.pnrType = pnrType;
        objectDigitalDataForFlexFlights.purchaseDate = originalIssueDateFormatted;
        objectDigitalDataForFlexFlights.purchaseType = this.getpurchaseType(customerDataOB);
        objectDigitalDataForFlexFlights.slice1OriginalDate = originalDepartureDate;
        objectDigitalDataForFlexFlights.slice2OriginalDate = originalReturnDate;
        objectDigitalDataForFlexFlights.slice3OriginalDate = this.getSlice3OriginalDate( model.rawSlicesInfo );
        objectDigitalDataForFlexFlights.slice4OriginalDate = this.getSlice4OriginalDate( model.rawSlicesInfo );
        objectDigitalDataForFlexFlights.specialMeal = this.getMeal();
        objectDigitalDataForFlexFlights.voucherDiscount = voucherDiscount;
        objectDigitalDataForFlexFlights.aviosRedeemed = aviosDiscount;
        objectDigitalDataForFlexFlights.passengersInfo = passengersInfo;
        objectDigitalDataForFlexFlights.pricesInfo = pricesInfo;
        objectDigitalDataForFlexFlights.flightType = flightType;
        objectDigitalDataForFlexFlights.rolCip = this.getRolCIP(customerDataOB);
        objectDigitalDataForFlexFlights.currency = this.getCurrency();
        objectDigitalDataForFlexFlights.reference = this.getPRN();
        objectDigitalDataForFlexFlights.bookingClass = this.getBookingClass(model);
        objectDigitalDataForFlexFlights.airportSeg = this.getAirportSeg(model);
        return objectDigitalDataForFlexFlights;
    };

    private generateObjectDigitalDataForOnHold = (
        flightStatus: string,
        flightType, slicesDates: Array<string> = [],
        airportSeg: string,
        passengersInfo,
        flightHaul, slices: datalayerServiceTypes.Slices[],
        model:OnHoldModel
    ): datalayerServiceTypes.TypeDigitalDataForFlexFlights => {
        const customerDataOB = JSON.parse(sessionStorage.getItem('customerDataOB'));
        let departureDate:string = '';
        let returnDate:string = '';
        let searchDest:string = '';
        let searchOD:string = '';
        const fareFamilies: string[] = [], cabins: string[] = [];
        let isMultiCity: boolean = this.isMultiCityTrip(slices);
        let cabinClass = '';
        const searchCountries = `${model?.generalInfo?.origin?.city.countryCode}-${model?.generalInfo?.destination?.city.countryCode}`;
        const advancePurchase = (this.getDifferenceInDays(new Date(slicesDates[0]), new Date())).toString()

        const obj: datalayerServiceTypes.TypeDigitalDataForFlexFlights =  {
            aviosEarned: null,
            changeAcceptance: null,
            changeType: null,
            flightStatus,
            flightHaul: flightHaul,
            originalAdvancePurchase: null,
            originalDate: '',
            originalLengthStay: null,
            lengthStay: null,
            pnrType: null,
            purchaseDate: null,
            purchaseType: null,
            slice1OriginalDate: null,
            slice2OriginalDate: null,
            slice3OriginalDate: null,
            slice4OriginalDate: null,
            specialMeal: null,
            voucherDiscount: null,
            aviosRedeemed :null,
            passengersInfo,
            pricesInfo : null,
            flightType,
            rolCip : this.getRolCIP(customerDataOB),
            currency : this.getCurrency(),
            reference: this.getPRN(),
            bookingClass: null,
            airportSeg,
            slices,
            searchCountries,
            searchOrigin : this.getSearchOrigin(model, slices),
            advancePurchase,
            searchOD,
            searchDest,
        }
        slicesDates.forEach((date, index) => {
            const k = `slice${index + 1}OriginalDate`;
            obj[k] = this.$filter('DateFormatFilter')(date).formatedDate;
            obj.originalDate += (index > 0 ? '-': '') + obj[k];
            if(index === 0) {
                departureDate = obj[k];
                returnDate = departureDate;
            }
            else returnDate = obj[k];
        });
        obj.lengthStay = departureDate !== returnDate ? this.getDaysDifference(returnDate, departureDate) : 0;
        for(let i = 0; i < slices.length; i++) {
            if (slices[i].segments.length > 0) {
                if (!obj[`slice${i + 1}Flights`]) {
                    obj[`slice${i + 1}Flights`] = '';
                } else {
                    obj[`slice${i + 1}Flights`] = '';
                }
                if (!obj[`slice${i + 1}Operator`]) {
                    obj[`slice${i + 1}Operator`] = '';
                } else {
                    obj[`slice${i + 1}Operator`] = '';
                }
                for (let j = 0; j < slices[i].segments.length; j++) {
                    fareFamilies[i] = fareFamilies[i] || '';
                    cabins[i] = cabins[i] || '';
                    fareFamilies[i] += (fareFamilies[i].length > 0 ? ',' : '') + (slices[i].segments[j].cabin.fareFamily || MMBDatalayerConstants.DATALAYER_VALUES.FARE_FAMILY_STANDARD);
                    cabins[i] += (cabins[i].length > 0 ? '-' : '') + (slices[i].segments[j].cabin.bookingClass || MMBDatalayerConstants.DATALAYER_VALUES.CABIN_FAMILY_STANDARD);
                    obj[`slice${i+1}Flights`] +=
                        (obj[`slice${i+1}Flights`].length > 0 ? '-' : '') +
                        slices[i].segments[j].flight.operationalDisclosure + (slices[i].segments[j].flight.operationalFlightNumber || slices[i].segments[j].flight.marketingFlightNumber);
                    obj[`slice${i+1}Operator`] +=
                        (obj[`slice${i+1}Operator`].length > 0 ? '-' : '') +
                        slices[i].segments[j].flight.operationalDisclosure;
                    if (slices[i].segments[j].cabin && angular.isString(slices[i].segments[0].cabin.bookingClass)) {
                        cabinClass = cabinClass === '' || MMBDatalayerConstants.SEGMENT_CABIN_PRIORITY[cabinClass] > MMBDatalayerConstants.SEGMENT_CABIN_PRIORITY[slices[i].segments[j].cabin.bookingClass.charAt(0)]
                            ? slices[i].segments[j].cabin.bookingClass.charAt(0) : cabinClass;
                    }
                }
            }
            obj[`slice${i+1}Cabin`] = cabins[i];
            let sliceRoute = slices[i].segments[0].departure.city.code + '-' + slices[i].segments[0].arrival.city.code;

            if(isMultiCity){
                sliceRoute = slices[i].segments.length>1 ? slices[i].segments[0].departure.city.code + '-' + slices[i].segments[slices[i].segments.length-1].arrival.city.code : sliceRoute;
                searchDest += `${searchDest.length > 0 ? '-':''}${slices[i].segments[slices[i].segments.length - 1].arrivalCity?.code}`
                searchOD += `${searchOD.length > 0 ? '/' : ''}${slices[i].segments[0].departure.city?.code + '-' + slices[i].segments[slices[i].segments.length-1].arrival.city?.code}`

            } else {
                for(let j = 1; j < slices[i].segments.length; j++){
                    sliceRoute = sliceRoute + '-' + slices[i].segments[j].arrival.city.code;
                }
                searchDest = `${model?.generalInfo?.destination?.city.code}`;
                searchOD = `${model?.generalInfo?.origin?.city.code}-${model?.generalInfo?.destination?.city.code}`;

            }
            obj[`slice${i+1}Routing`] = sliceRoute;
            let fareFamily = '';
            slices[i].segments.forEach(segments => {
                this.CommonsSessionStorageService.get('fareFamilyConditionsInfo').forEach((fare) => {
                    if(fare.commercialCode === segments.cabin.fareFamily) {
                        fareFamily+= (fareFamily==='' ? '' : '-') + fare.commercialNameES;
                    }
                });
            });
            obj[`slice${i+1}FareFamily`] = fareFamily;
        }
        obj.searchDest = searchDest;
        obj.searchOD = searchOD;

        return obj;
    }

    private isMultiCityTrip = (slices): boolean => {
        let firstSliceLastSegment = slices[0].segments[slices[0].segments.length - 1];
        let lastSliceFirstSegment = slices[slices.length - 1].segments[0];
        let isMultiCity = firstSliceLastSegment.arrival.city?.code !== lastSliceFirstSegment?.departureCity?.code;
        this.CommonsSessionStorageService.set('multiCitySearch',isMultiCity);

        return isMultiCity;
    }

    private getSearchOrigin = (model: OnHoldModel, slices: datalayerServiceTypes.Slices[]) : string  => {
        let searchOrigin : string = '';
        if (model.generalInfo.flightType === this.MmBAppConstants.OH_FLIGHT_TYPES.MULTITRIP) {
            for (let i = 0; i < slices.length; i++) {
                searchOrigin += `${searchOrigin.length > 0 ? '-' : ''}${slices[i].segments[0].departureCity.code}`;
            }
        } else {
                searchOrigin += `${model?.generalInfo?.origin?.city.code}`;
        }
        return searchOrigin
    }

    private getAvios = () => {
        const calculatedPoints: any = this.CommonsSessionStorageService.get('CalculatedPoints');
        return calculatedPoints && calculatedPoints.Avios ? calculatedPoints.Avios : null;
    };

    private getChangeAcceptance = (model, isDisrupted) => {
        return isDisrupted ? this.isTotal(model) : null ;

    };

    private isTotal = (model) =>{
        let isTotal = true;
        model.rawSlicesInfo.forEach((sliceid) => {
            sliceid.segments.forEach((segment) => {
                if(segment.status.code == 'HK') isTotal= false;
            });
        });
        return isTotal;
    };

    private getChangeType = () => {
        const bookingInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
        return bookingInfo.order.status;
    };

    private getpurchaseType = (customerDataOB) => {
        const purchaseType = (customerDataOB && customerDataOB.puntos) ? customerDataOB.puntos : (customerDataOB && customerDataOB.descuento) ? customerDataOB.descuento : null;
        return purchaseType;
    };

    private getSlice3OriginalDate = (flightsModel) =>{
        if(flightsModel.length === 3){
            const date = flightsModel[2].arrivalDateTime;
            const slice3OriginalDate = this.$filter('DateFormatFilter')(date).formatedDate;
            return slice3OriginalDate;
        } else return null;
    };

    private getSlice4OriginalDate = (flightsModel) =>{
        if(flightsModel.length === 4){
            const date = flightsModel[3].arrivalDateTime;
            const slice4OriginalDate = this.$filter('DateFormatFilter')(date).formatedDate;
            return slice4OriginalDate;
        } else return null;
    };

    private getMeal = () => {
        const meal: any = this.CommonsSessionStorageService.get('specialMealsCopy');
        const hasMeal = meal && meal.length >0 ? true : false;
        return hasMeal;
    };

    private getRolCIP = (customerDataOB) => {
        if(customerDataOB && customerDataOB.rolCIP){
            return customerDataOB.rolCIP;
        }
    };

    private getCurrency = () => {
        const bookingInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
        return (bookingInfo?.order?.price?.currency) ? bookingInfo.order.price.currency : null;
    };

    private getPRN = () => {
        const PNR: any = this.CommonsSessionStorageService.get('PNR');
        return PNR ? PNR : null;
    };

    private getBookingClass = (model) => {
        let cabinClass: string = '';
        model.rawSlicesInfo.forEach((slice) => {
            slice.segments.forEach((segment) => {
                if (segment.cabin && angular.isString(segment.cabin.bookingClass)) {
                    cabinClass = cabinClass === '' || MMBDatalayerConstants.SEGMENT_CABIN_PRIORITY[cabinClass] > MMBDatalayerConstants.SEGMENT_CABIN_PRIORITY[segment.cabin.bookingClass.charAt(0)]
                        ? segment.cabin.bookingClass.charAt(0) : cabinClass;
                }
            });
        });
        return cabinClass;
    };

    private getAirportSeg = (model) => {
        const isMultipleTrip = this.CommonsSessionStorageService.get('multiCitySearch');
        let airportSeg;
        if(isMultipleTrip){
            model.forEach(slice => {
                let originDestination = '';
                originDestination = slice.segments.length>1 ? slice.segments[0].departure.code + '-' + slice.segments[1].arrival.code : slice.segments[0].departure.code + '-' + slice.segments[0].arrival.code;
                airportSeg +=
                    (airportSeg.length > 0 ? ',' : '') +
                    originDestination;
            });
        } else {
            airportSeg = model.rawSlicesInfo[0].segments[0].departure.code + '-' + model.rawSlicesInfo[0].segments[0].arrival.code;
        }
        return airportSeg;
    };

    /**
    * Gets the difference in days between 2 dates given.
    */
    private getDaysDifference = (maxDate, minDate) => {
        var splittedmaxDate, splittedminDate, formattedmaxDate, formattedminDate, difference, daysDiff;
        splittedmaxDate = maxDate.split('/');
        splittedminDate = minDate.split('/');
        formattedmaxDate = Date.UTC(splittedmaxDate[2], splittedmaxDate[1] - 1, splittedmaxDate[0]);
        formattedminDate = Date.UTC(splittedminDate[2], splittedminDate[1] - 1, splittedminDate[0]);
        difference = formattedmaxDate - formattedminDate;
        daysDiff = Math.floor(difference / (1000 * 60 * 60 * 24));

        return daysDiff;
    };

    /**
     * Get app market
     * @returns {String}
     */
    getAppMarket = () => {
        return this.CommonsUtilService.getAppMarket();
    };

    /**
     * Get info prefix from app market
     * @returns {Object} code and countryCode info
     */
    getPrefixFromMarket = () => {
        return this.CommonsUtilService.getPrefixFromMarket();
    };


    /**
     * This functions generate and update QUADRIGAM page.
     *  */
    updateQuadrigam = (quadrigam, process?:string, step?:string) => {
        let newProcess = process || MMBDatalayerConstants.DIGITAL_DATA_PROCESS[quadrigam];
        let newStep = step || MMBDatalayerConstants.DIGITAL_DATA_STEP[quadrigam];

        this.MmBDatalayerUtilsService.updateDatalayerInfo(newProcess, newStep, quadrigam);
    };

    getFareFamilyConditions = (fareData, fareConditions) => {
        let fareDataConditions = [], fareIndex, conditionsIndex, cabin, fareCondArray;

        for (fareIndex = 0; fareIndex < fareConditions.length; fareIndex++) {
            if (fareData === fareConditions[fareIndex].commercialCode) {
                cabin = this.$translate.use() !== 'es' || !fareConditions[fareIndex].commercialNameES ? fareConditions[fareIndex].commercialName : fareConditions[fareIndex].commercialNameES;

                fareCondArray = fareConditions[fareIndex].conditions.filter(Boolean);
                fareConditions[fareIndex].conditions = angular.copy(fareCondArray);

                for (conditionsIndex = 0; conditionsIndex < fareConditions[fareIndex].conditions.length; conditionsIndex++) {
                    fareDataConditions.push({
                        cabin: cabin,
                        cabinType: fareConditions[fareIndex].cabinType,
                        code: fareConditions[fareIndex].conditions[conditionsIndex].code,
                        name: fareConditions[fareIndex].conditions[conditionsIndex].name,
                        title: fareConditions[fareIndex].conditions[conditionsIndex].extendedInfo.title,
                        message: fareConditions[fareIndex].conditions[conditionsIndex].extendedInfo.message,
                        units: fareConditions[fareIndex].conditions[conditionsIndex].units
                    });
                    //SRV: Bug in FlightsCardViewComponent with REFUND
                }
            }
        }
        return fareDataConditions;
    }

    /**
    * Return a Object with all information to show comunications lost view
    * @param {Object} confirmationInfo Object with all information return issue service when error code is 417
    * @param {Array<Object>} creditCardTypes All information credit card return in payment method creditCard
    */
    getCommunicationsLostInfo = (confirmationInfo, creditCardTypes) => {
        let i;
        const communicationLostModel = {
            currency: this.CurrencyService.getCurrenciesAsMap(confirmationInfo && confirmationInfo.contextMetadata ? confirmationInfo.contextMetadata.currencies : null)[confirmationInfo && confirmationInfo.order ? confirmationInfo.order.price.currency : null],
            pnr: confirmationInfo && confirmationInfo.order ? confirmationInfo.order.bookingReferences[0].reference : null,
            paymentItems: {},
            ancillaries: confirmationInfo && confirmationInfo.order && confirmationInfo.order.orderItems ? this.getAncillariesInfo(confirmationInfo.order.orderItems, confirmationInfo.order.slices) : null,
            aviosRedeemed: {}
        };
        if (confirmationInfo && confirmationInfo.paymentItems) {
            for (i = 0; i < confirmationInfo.paymentItems.length; i++) {
                switch (confirmationInfo.paymentItems[i].type) {
                        case this.MmBAppConstants.PAYMENT_TYPES.CREDIT_CARD:
                            communicationLostModel.paymentItems[this.MmBAppConstants.PAYMENT_TYPES.CREDIT_CARD] = {
                                total: this.CurrencyService.formatPrice(communicationLostModel.currency, confirmationInfo.paymentItems[i].total, true) + (communicationLostModel.currency.description ? ' (' + communicationLostModel.currency.description + ')' : ''),
                                authorization: confirmationInfo.paymentItems[i].authorization,
                                creditCardNumber: confirmationInfo.paymentMethod.cardNumber,
                                cardDescription: this.getCreditCardDescription(confirmationInfo.paymentMethod.cardTypeId, creditCardTypes)
                            };
                            break;
                        case this.MmBAppConstants.PAYMENT_TYPES.AVIOS:
                            communicationLostModel.paymentItems[this.MmBAppConstants.PAYMENT_TYPES.AVIOS] = {
                                dicount: '-' + this.CurrencyService.formatPrice(communicationLostModel.currency, confirmationInfo.paymentItems[i].total, true) + ' (' + communicationLostModel.currency.description + ')',
                                authorization: confirmationInfo.paymentItems[i].authorization,
                                aviosRedeemed: confirmationInfo.paymentItems[i].aviosRedeemed
                            };
                            communicationLostModel.aviosRedeemed = confirmationInfo.paymentItems[i].aviosRedeemed;
                            break;
                        case this.MmBAppConstants.PAYMENT_TYPES.VOUCHER:
                            communicationLostModel.paymentItems[this.MmBAppConstants.PAYMENT_TYPES.VOUCHER] = {
                                dicount: '-' + this.CurrencyService.formatPrice(communicationLostModel.currency, confirmationInfo.paymentItems[i].total, true) + ' (' + communicationLostModel.currency.description + ')',
                                authorization: confirmationInfo.paymentItems[i].authorization
                            };
                            break;
                }
            }
        }
        return communicationLostModel;
    }

    getCreditCardDescription = (cardTypeId, creditCardTypes) => {
        let cardIndex = 0, cardFound = false;
        let cardDescription = '';
        if (creditCardTypes) {
            while (!cardFound && cardIndex < creditCardTypes.length) {
                if (cardTypeId === creditCardTypes[cardIndex].cardTypeId) {
                    cardFound = true;
                    cardDescription = creditCardTypes[cardIndex].description;
                }
                cardIndex++;
            }
        }
        return cardDescription;
    }

    getAncillariesInfo = (orderItems, slices) => {
        let orderItemsIndex, ancillariesInfo: any = {}, tripInfo, ancillariesInfoIndex = 0;
        for (orderItemsIndex = 0; orderItemsIndex < orderItems.length; orderItemsIndex++) {
            switch (orderItems[orderItemsIndex].type) {
                    case 'baggage':
                        if (!ancillariesInfo.BAGGAGES) {
                            ancillariesInfo.BAGGAGES = {
                                title: 'SUMMARY_ANCILLARIES_BAGGAGE_TITLE',
                                info: {},
                                viewInfo: { text: '', quantity: 1 }
                            };
                        } else {
                            ancillariesInfo.BAGGAGES.viewInfo.quantity++;
                        }
                        if (ancillariesInfo.BAGGAGES.info[orderItems[orderItemsIndex].sliceId]) {
                            ancillariesInfo.BAGGAGES.info[orderItems[orderItemsIndex].sliceId].baggages++;
                        } else {
                            tripInfo = this.getSliceDetailsById(orderItems[orderItemsIndex].sliceId, slices);
                            ancillariesInfo.BAGGAGES.info[orderItems[orderItemsIndex].sliceId] = { baggages: 1, trip: '(' + tripInfo.origin.city.description + '-' + tripInfo.arrival.city.description + ')' };
                        }
                        break;
                    case 'seat':
                        if (!ancillariesInfo.SEATS) {
                            ancillariesInfo.SEATS = {
                                title: 'SUMMARY_ANCILLARIES_SEATS_TITLE',
                                info: {},
                                viewInfo: { text: '' }
                            };
                        }
                        if (ancillariesInfo.SEATS.info[orderItems[orderItemsIndex].segmentId]) {
                            ancillariesInfo.SEATS.info[orderItems[orderItemsIndex].segmentId].seats += ',' + orderItems[orderItemsIndex].row + orderItems[orderItemsIndex].column;
                        } else {
                            tripInfo = this.getSegmentDetailsById(orderItems[orderItemsIndex].segmentId, slices);
                            ancillariesInfo.SEATS.info[orderItems[orderItemsIndex].segmentId] = { seats: orderItems[orderItemsIndex].row + orderItems[orderItemsIndex].column, trip: '(' + tripInfo.origin.city.description + '-' + tripInfo.arrival.city.description + ')' };
                        }
                        break;
            }
        }
        if (ancillariesInfo.SEATS) {
            angular.forEach(ancillariesInfo.SEATS.info, (value, id) => {
                ancillariesInfo.SEATS.viewInfo.text += value.seats + ' ' + value.trip + (ancillariesInfoIndex < Object.keys(ancillariesInfo.SEATS.info).length - 1 ? '. ' : '');
                ancillariesInfoIndex++;
            });
        }
        ancillariesInfoIndex = 0;
        if (ancillariesInfo.BAGGAGES) {
            angular.forEach(ancillariesInfo.BAGGAGES.info, (value, id) => {
                ancillariesInfo.BAGGAGES.viewInfo.text += value.baggages + ' ' + value.trip + (ancillariesInfoIndex < Object.keys(ancillariesInfo.BAGGAGES.info).length - 1 ? ', ' : '');
                ancillariesInfoIndex++;
            });
        }
        return ancillariesInfo;
    }

    getSliceDetailsById = (sliceId, slices) => {
        let sliceFounded = false, sliceIndex = 0, sliceInfo = {};
        while (!sliceFounded && sliceIndex < slices.length) {
            if (slices[sliceIndex].sliceId === sliceId) {
                sliceFounded = true;
                sliceInfo = {
                    origin: slices[sliceIndex].segments[0].departure,
                    arrival: slices[sliceIndex].segments[slices[sliceIndex].segments.length - 1].arrival
                };
            }
            sliceIndex++;
        }
        return sliceInfo;
    }

    getSegmentDetailsById = (segmentId, slices) => {
        let sliceIndex = 0, segmentFounded = false, segmentIndex, segmentInfo = {};
        while (!segmentFounded && sliceIndex < slices.length) {
            segmentIndex = 0;
            while (!segmentFounded && segmentIndex < slices[sliceIndex].segments.length) {
                if (slices[sliceIndex].segments[segmentIndex].id === segmentId) {
                    segmentFounded = true;
                    segmentInfo = {
                        origin: slices[sliceIndex].segments[segmentIndex].departure,
                        arrival: slices[sliceIndex].segments[segmentIndex].arrival
                    };
                }
                segmentIndex++;
            }
            sliceIndex++;
        }
        return segmentInfo;
    }

    /**
     * This functions returns the process depending on the quadrigam and on the order status
     * @returns {String} process.
     *  */
    getProcessByStatus = (quadrigam, orderStatus) : string => {
        var process = null;

        if(this.MmBAppConstants.UN_UNTK_QUADRIGAMS.includes(quadrigam)) {
            switch (orderStatus) {
            case this.MmBAppConstants.ORDER_STATUS_VALUES.CANCELATION_FLAG:
                process = MMBDatalayerConstants.MMB_UN_UNTK_PROCESSES.UN;
                break;
            case this.MmBAppConstants.ORDER_STATUS_VALUES.CANCELATION_REACOM_FLAG:
                process = MMBDatalayerConstants.MMB_UN_UNTK_PROCESSES.UNTK;
                break;
            }
        }
        return process;
    }

    getDifferenceInDays = (departureDate:Date, currentDate:Date):number => {
        return Math.round((departureDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));
    }
}
